//@ts-nocheck
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Ryddm API
 * Documentation for public Ryddm API
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://api.staging.ryddm.com/v1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = portableFetch
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name: "RequiredError";
  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 *
 * @export
 * @interface AddStreamRequest
 */
export interface AddStreamRequest {
  /**
   *
   * @type {string}
   * @memberof AddStreamRequest
   */
  trackId?: string;
}

/**
 *
 * @export
 * @interface BlockCommentRequest
 */
export interface BlockCommentRequest {
  /**
   *
   * @type {string}
   * @memberof BlockCommentRequest
   */
  commentId: string;
  /**
   *
   * @type {string}
   * @memberof BlockCommentRequest
   */
  reportId: string;
}

/**
 *
 * @export
 * @interface BlockCommentResponse
 */
export interface BlockCommentResponse {
  /**
   *
   * @type {string}
   * @memberof BlockCommentResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockCommentsRequest
 */
export interface BlockCommentsRequest {
  /**
   *
   * @type {string}
   * @memberof BlockCommentsRequest
   */
  moderatorId: string;
  /**
   *
   * @type {string}
   * @memberof BlockCommentsRequest
   */
  postId?: string;
  /**
   *
   * @type {string}
   * @memberof BlockCommentsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface BlockCommentsResponse
 */
export interface BlockCommentsResponse {
  /**
   *
   * @type {string}
   * @memberof BlockCommentsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockNotificationsRequest
 */
export interface BlockNotificationsRequest {
  /**
   *
   * @type {string}
   * @memberof BlockNotificationsRequest
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof BlockNotificationsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface BlockNotificationsResponse
 */
export interface BlockNotificationsResponse {
  /**
   *
   * @type {string}
   * @memberof BlockNotificationsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockPostRequest
 */
export interface BlockPostRequest {
  /**
   *
   * @type {string}
   * @memberof BlockPostRequest
   */
  postId: string;
  /**
   *
   * @type {string}
   * @memberof BlockPostRequest
   */
  reportId: string;
}

/**
 *
 * @export
 * @interface BlockPostResponse
 */
export interface BlockPostResponse {
  /**
   *
   * @type {string}
   * @memberof BlockPostResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockPostsRequest
 */
export interface BlockPostsRequest {
  /**
   *
   * @type {string}
   * @memberof BlockPostsRequest
   */
  moderatorId: string;
  /**
   *
   * @type {string}
   * @memberof BlockPostsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface BlockPostsResponse
 */
export interface BlockPostsResponse {
  /**
   *
   * @type {string}
   * @memberof BlockPostsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockReportsRequest
 */
export interface BlockReportsRequest {
  /**
   *
   * @type {string}
   * @memberof BlockReportsRequest
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof BlockReportsRequest
   */
  moderatorId: string;
  /**
   *
   * @type {string}
   * @memberof BlockReportsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface BlockReportsResponse
 */
export interface BlockReportsResponse {
  /**
   *
   * @type {string}
   * @memberof BlockReportsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockTipsRequest
 */
export interface BlockTipsRequest {
  /**
   *
   * @type {string}
   * @memberof BlockTipsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface BlockTipsResponse
 */
export interface BlockTipsResponse {
  /**
   *
   * @type {string}
   * @memberof BlockTipsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BlockTrackRequest
 */
export interface BlockTrackRequest {
  /**
   *
   * @type {string}
   * @memberof BlockTrackRequest
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof BlockTrackRequest
   */
  trackId: string;
}

/**
 *
 * @export
 * @interface BlockTracksRequest
 */
export interface BlockTracksRequest {
  /**
   *
   * @type {string}
   * @memberof BlockTracksRequest
   */
  moderatorId: string;
  /**
   *
   * @type {string}
   * @memberof BlockTracksRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface BlockUserRequest
 */
export interface BlockUserRequest {
  /**
   *
   * @type {string}
   * @memberof BlockUserRequest
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof BlockUserRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface BlockUserResponse
 */
export interface BlockUserResponse {
  /**
   *
   * @type {string}
   * @memberof BlockUserResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface BoostTrackRequest
 */
export interface BoostTrackRequest {
  /**
   *
   * @type {string}
   * @memberof BoostTrackRequest
   */
  purchaseSource: string;
  /**
   *
   * @type {string}
   * @memberof BoostTrackRequest
   */
  purchaseSourceId: string;
  /**
   *
   * @type {string}
   * @memberof BoostTrackRequest
   */
  trackId: string;
  /**
   *
   * @type {string}
   * @memberof BoostTrackRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface BoostTrackResponse
 */
export interface BoostTrackResponse {
  /**
   *
   * @type {string}
   * @memberof BoostTrackResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CancelSubscriptionRequest
 */
export interface CancelSubscriptionRequest {
  /**
   *
   * @type {string}
   * @memberof CancelSubscriptionRequest
   */
  artistId: string;
}

/**
 *
 * @export
 * @interface CancelSubscriptionResponse
 */
export interface CancelSubscriptionResponse {
  /**
   *
   * @type {string}
   * @memberof CancelSubscriptionResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CancelSubscriptionsRequest
 */
export interface CancelSubscriptionsRequest {
  /**
   *
   * @type {string}
   * @memberof CancelSubscriptionsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface CancelSubscriptionsResponse
 */
export interface CancelSubscriptionsResponse {
  /**
   *
   * @type {string}
   * @memberof CancelSubscriptionsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CreateArtistSubscriptionRequest
 */
export interface CreateArtistSubscriptionRequest {
  /**
   *
   * @type {string}
   * @memberof CreateArtistSubscriptionRequest
   */
  artistId?: string;
}

/**
 *
 * @export
 * @interface CreateCommentRequest
 */
export interface CreateCommentRequest {
  /**
   *
   * @type {string}
   * @memberof CreateCommentRequest
   */
  postId: string;
  /**
   *
   * @type {string}
   * @memberof CreateCommentRequest
   */
  targetId: string;
  /**
   *
   * @type {string}
   * @memberof CreateCommentRequest
   */
  targetType: string;
  /**
   *
   * @type {string}
   * @memberof CreateCommentRequest
   */
  text: string;
}

/**
 *
 * @export
 * @interface CreateCommentResponse
 */
export interface CreateCommentResponse {
  /**
   *
   * @type {string}
   * @memberof CreateCommentResponse
   */
  id?: string;
}

/**
 *
 * @export
 * @interface CreateConnectedAccountResponse
 */
export interface CreateConnectedAccountResponse {
  /**
   *
   * @type {string}
   * @memberof CreateConnectedAccountResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CreateFileResponse
 */
export interface CreateFileResponse {
  /**
   *
   * @type {UserFile}
   * @memberof CreateFileResponse
   */
  file?: UserFile;
}

/**
 *
 * @export
 * @interface CreateNotificationRequestBody
 */
export interface CreateNotificationRequestBody {
  /**
   *
   * @type {Array<string>}
   * @memberof CreateNotificationRequestBody
   */
  dynamicData?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  entityType?: string;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  event: string;
  /**
   *
   * @type {MainParentEntities}
   * @memberof CreateNotificationRequestBody
   */
  parentEntities?: MainParentEntities;
  /**
   *
   * @type {number}
   * @memberof CreateNotificationRequestBody
   */
  priority?: number;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  sourceUserId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  targetUserId: string;
  /**
   *
   * @type {string}
   * @memberof CreateNotificationRequestBody
   */
  type: string;
}

/**
 *
 * @export
 * @interface CreateNotificationResponseBody
 */
export interface CreateNotificationResponseBody {
  /**
   *
   * @type {string}
   * @memberof CreateNotificationResponseBody
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CreatePaymentAccountResponse
 */
export interface CreatePaymentAccountResponse {
  /**
   *
   * @type {string}
   * @memberof CreatePaymentAccountResponse
   */
  accountLink?: string;
}

/**
 *
 * @export
 * @interface CreatePaymentPayoutResponse
 */
export interface CreatePaymentPayoutResponse {
  /**
   *
   * @type {number}
   * @memberof CreatePaymentPayoutResponse
   */
  arrivalDate?: number;
}

/**
 *
 * @export
 * @interface CreatePayoutRequest
 */
export interface CreatePayoutRequest {
  /**
   *
   * @type {number}
   * @memberof CreatePayoutRequest
   */
  payoutAmount?: number;
}

/**
 *
 * @export
 * @interface CreatePayoutResponse
 */
export interface CreatePayoutResponse {
  /**
   *
   * @type {number}
   * @memberof CreatePayoutResponse
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof CreatePayoutResponse
   */
  arrivalDate?: number;
  /**
   *
   * @type {string}
   * @memberof CreatePayoutResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface CreatePostRequest
 */
export interface CreatePostRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePostRequest
   */
  fileId?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePostRequest
   */
  fileType?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePostRequest
   */
  text?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CreatePostRequest
   */
  trackIds?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof CreatePostRequest
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof CreatePostRequest
   */
  visibility: string;
}

/**
 *
 * @export
 * @interface CreatePostResponse
 */
export interface CreatePostResponse {
  /**
   *
   * @type {string}
   * @memberof CreatePostResponse
   */
  message?: string;
  /**
   *
   * @type {Post}
   * @memberof CreatePostResponse
   */
  post?: Post;
}

/**
 *
 * @export
 * @interface CreateReportRequest
 */
export interface CreateReportRequest {
  /**
   *
   * @type {string}
   * @memberof CreateReportRequest
   */
  entityId: string;
  /**
   *
   * @type {string}
   * @memberof CreateReportRequest
   */
  entityType: string;
  /**
   *
   * @type {string}
   * @memberof CreateReportRequest
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CreateReportRequest
   */
  reportType: string;
  /**
   *
   * @type {string}
   * @memberof CreateReportRequest
   */
  targetUserId: string;
}

/**
 *
 * @export
 * @interface CreateReportResponse
 */
export interface CreateReportResponse {
  /**
   *
   * @type {string}
   * @memberof CreateReportResponse
   */
  message?: string;
  /**
   *
   * @type {ReportMessage}
   * @memberof CreateReportResponse
   */
  reportMessage?: ReportMessage;
}

/**
 *
 * @export
 * @interface CreateSubscriptionRequest
 */
export interface CreateSubscriptionRequest {
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionRequest
   */
  artistId: string;
}

/**
 *
 * @export
 * @interface CreateSubscriptionResponse
 */
export interface CreateSubscriptionResponse {
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  clientSecretType?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  customerId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  ephemeralKey?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  paymentIntentClientSecret?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionResponse
   */
  targetUsername?: string;
}

/**
 *
 * @export
 * @interface CreateTipRequest
 */
export interface CreateTipRequest {
  /**
   *
   * @type {number}
   * @memberof CreateTipRequest
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateTipRequest
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipRequest
   */
  targetId: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipRequest
   */
  targetType: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipRequest
   */
  targetUserId: string;
}

/**
 *
 * @export
 * @interface CreateTipResponse
 */
export interface CreateTipResponse {
  /**
   *
   * @type {string}
   * @memberof CreateTipResponse
   */
  customerId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipResponse
   */
  ephemeralKey?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTipResponse
   */
  paymentIntentClientSecret?: string;
}

/**
 *
 * @export
 * @interface CreateTrackRequest
 */
export interface CreateTrackRequest {
  /**
   *
   * @type {string}
   * @memberof CreateTrackRequest
   */
  coverFileId: string;
  /**
   *
   * @type {string}
   * @memberof CreateTrackRequest
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTrackRequest
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CreateTrackRequest
   */
  trackFileId: string;
  /**
   *
   * @type {number}
   * @memberof CreateTrackRequest
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof CreateTrackRequest
   */
  visibility?: string;
}

/**
 *
 * @export
 * @interface CreateTrackResponse
 */
export interface CreateTrackResponse {
  /**
   *
   * @type {string}
   * @memberof CreateTrackResponse
   */
  message?: string;
  /**
   *
   * @type {ModelsTrack}
   * @memberof CreateTrackResponse
   */
  track?: ModelsTrack;
}

/**
 *
 * @export
 * @interface CreateTransferRequest
 */
export interface CreateTransferRequest {
  /**
   *
   * @type {number}
   * @memberof CreateTransferRequest
   */
  transferAmount: number;
  /**
   *
   * @type {string}
   * @memberof CreateTransferRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface CreateTransferResponse
 */
export interface CreateTransferResponse {
  /**
   *
   * @type {string}
   * @memberof CreateTransferResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransferResponse
   */
  transferId?: string;
}

/**
 *
 * @export
 * @interface DeleteCommentResponse
 */
export interface DeleteCommentResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteCommentResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteCommentsRequest
 */
export interface DeleteCommentsRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteCommentsRequest
   */
  postId?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteCommentsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface DeleteCommentsResponse
 */
export interface DeleteCommentsResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteCommentsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteFileRequest
 */
export interface DeleteFileRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteFileRequest
   */
  fileId: string;
}

/**
 *
 * @export
 * @interface DeleteFileResponse
 */
export interface DeleteFileResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteFileResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteFirebaseProfileRequest
 */
export interface DeleteFirebaseProfileRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteFirebaseProfileRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface DeleteFirebaseProfileResponse
 */
export interface DeleteFirebaseProfileResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteFirebaseProfileResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteIOSPurchasesRequest
 */
export interface DeleteIOSPurchasesRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteIOSPurchasesRequest
   */
  purchaseId?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteIOSPurchasesRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface DeleteIOSPurchasesResponse
 */
export interface DeleteIOSPurchasesResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteIOSPurchasesResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationByTermRequest
 */
export interface DeleteNotificationByTermRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermRequest
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermRequest
   */
  entityType: string;
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermRequest
   */
  notificationEvent: string;
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermRequest
   */
  notificationType?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermRequest
   */
  targetUserId: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationByTermResponse
 */
export interface DeleteNotificationByTermResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationByTermResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationRequest
 */
export interface DeleteNotificationRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationRequest
   */
  notificationId: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationResponse
 */
export interface DeleteNotificationResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationsRequest
 */
export interface DeleteNotificationsRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationsRequest
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface DeleteNotificationsResponse
 */
export interface DeleteNotificationsResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteNotificationsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeletePostsRequest
 */
export interface DeletePostsRequest {
  /**
   *
   * @type {string}
   * @memberof DeletePostsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface DeletePostsResponse
 */
export interface DeletePostsResponse {
  /**
   *
   * @type {string}
   * @memberof DeletePostsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteReportsRequest
 */
export interface DeleteReportsRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteReportsRequest
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteReportsRequest
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface DeleteReportsResponse
 */
export interface DeleteReportsResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteReportsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteStripeConnectedAccountRequest
 */
export interface DeleteStripeConnectedAccountRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeConnectedAccountRequest
   */
  stripeConnectedAccountId: string;
}

/**
 *
 * @export
 * @interface DeleteStripeConnectedAccountResponse
 */
export interface DeleteStripeConnectedAccountResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeConnectedAccountResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteStripeCustomerRequest
 */
export interface DeleteStripeCustomerRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeCustomerRequest
   */
  stripeCustomerId: string;
}

/**
 *
 * @export
 * @interface DeleteStripeCustomerResponse
 */
export interface DeleteStripeCustomerResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeCustomerResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteStripeEntitiesRequest
 */
export interface DeleteStripeEntitiesRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeEntitiesRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface DeleteStripeEntitiesResponse
 */
export interface DeleteStripeEntitiesResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteStripeEntitiesResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteTipsRequest
 */
export interface DeleteTipsRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteTipsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface DeleteTipsResponse
 */
export interface DeleteTipsResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteTipsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteTrackResponse
 */
export interface DeleteTrackResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteTrackResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteTracksRequest
 */
export interface DeleteTracksRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteTracksRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface DeleteTracksResponse
 */
export interface DeleteTracksResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteTracksResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface DeleteUserRequest
 */
export interface DeleteUserRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteUserRequest
   */
  confirmationCode: string;
}

/**
 *
 * @export
 * @interface DeleteUserResponse
 */
export interface DeleteUserResponse {
  /**
   *
   * @type {string}
   * @memberof DeleteUserResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface EndpointsPaymentsGetPaymentMethodRequest
 */
export interface EndpointsPaymentsGetPaymentMethodRequest {
  /**
   *
   * @type {string}
   * @memberof EndpointsPaymentsGetPaymentMethodRequest
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof EndpointsPaymentsGetPaymentMethodRequest
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof EndpointsPaymentsGetPaymentMethodRequest
   */
  last4?: string;
}

/**
 *
 * @export
 * @interface EndpointsTracksBlockTracksResponse
 */
export interface EndpointsTracksBlockTracksResponse {
  /**
   *
   * @type {string}
   * @memberof EndpointsTracksBlockTracksResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface ExchangeDisposableAuthCodeRequest
 */
export interface ExchangeDisposableAuthCodeRequest {
  /**
   *
   * @type {string}
   * @memberof ExchangeDisposableAuthCodeRequest
   */
  authCode: string;
}

/**
 *
 * @export
 * @interface ExchangeDisposableAuthCodeResponse
 */
export interface ExchangeDisposableAuthCodeResponse {
  /**
   *
   * @type {string}
   * @memberof ExchangeDisposableAuthCodeResponse
   */
  authToken?: string;
}

/**
 *
 * @export
 * @interface ExchangeTokenRequest
 */
export interface ExchangeTokenRequest {
  /**
   *
   * @type {string}
   * @memberof ExchangeTokenRequest
   */
  idToken: string;
}

/**
 *
 * @export
 * @interface ExchangeTokenResponse
 */
export interface ExchangeTokenResponse {
  /**
   *
   * @type {string}
   * @memberof ExchangeTokenResponse
   */
  authToken?: string;
  /**
   *
   * @type {string}
   * @memberof ExchangeTokenResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof ExchangeTokenResponse
   */
  onboardingStage?: string;
  /**
   *
   * @type {ModelsUser}
   * @memberof ExchangeTokenResponse
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface ExtendedComment
 */
export interface ExtendedComment {
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof ExtendedComment
   */
  likesNumber?: number;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  parentEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  parentEntityType?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  parentPostId?: string;
  /**
   *
   * @type {number}
   * @memberof ExtendedComment
   */
  repliesNumber?: number;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  text?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  userAvatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  userName?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedComment
   */
  userUsername?: string;
}

/**
 *
 * @export
 * @interface ExtendedTrack
 */
export interface ExtendedTrack {
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  coverFileId?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  name?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ExtendedTrack
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  trackFileId?: string;
  /**
   *
   * @type {number}
   * @memberof ExtendedTrack
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  userName?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  userUsername?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedTrack
   */
  visibility?: string;
}

/**
 *
 * @export
 * @interface GenerateConnectedAccountLinkResponse
 */
export interface GenerateConnectedAccountLinkResponse {
  /**
   *
   * @type {string}
   * @memberof GenerateConnectedAccountLinkResponse
   */
  accountLink?: string;
  /**
   *
   * @type {string}
   * @memberof GenerateConnectedAccountLinkResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetBalanceResponse
 */
export interface GetBalanceResponse {
  /**
   *
   * @type {number}
   * @memberof GetBalanceResponse
   */
  availableBalance?: number;
  /**
   *
   * @type {string}
   * @memberof GetBalanceResponse
   */
  availableBalanceCurrency?: string;
  /**
   *
   * @type {string}
   * @memberof GetBalanceResponse
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof GetBalanceResponse
   */
  pendingBalance?: number;
  /**
   *
   * @type {string}
   * @memberof GetBalanceResponse
   */
  pendingBalanceCurrency?: string;
}

/**
 *
 * @export
 * @interface GetBoostedTracksResponse
 */
export interface GetBoostedTracksResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetBoostedTracksResponse
   */
  trackIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetChartTracksHandlerTracks
 */
export interface GetChartTracksHandlerTracks {
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetChartTracksHandlerTracks
   */
  exclusive?: Array<ExtendedTrack>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetChartTracksHandlerTracks
   */
  latest?: Array<ExtendedTrack>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetChartTracksHandlerTracks
   */
  popular?: Array<ExtendedTrack>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetChartTracksHandlerTracks
   */
  trending?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface GetChartTracksResponse
 */
export interface GetChartTracksResponse {
  /**
   *
   * @type {string}
   * @memberof GetChartTracksResponse
   */
  message?: string;
  /**
   *
   * @type {GetChartTracksHandlerTracks}
   * @memberof GetChartTracksResponse
   */
  tracks?: GetChartTracksHandlerTracks;
}

/**
 *
 * @export
 * @interface GetCommentResponse
 */
export interface GetCommentResponse {
  /**
   *
   * @type {ExtendedComment}
   * @memberof GetCommentResponse
   */
  comment?: ExtendedComment;
  /**
   *
   * @type {string}
   * @memberof GetCommentResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetCommentsResponse
 */
export interface GetCommentsResponse {
  /**
   *
   * @type {Array<ExtendedComment>}
   * @memberof GetCommentsResponse
   */
  comments?: Array<ExtendedComment>;
}

/**
 *
 * @export
 * @interface GetConnectedAccountReadyResponse
 */
export interface GetConnectedAccountReadyResponse {
  /**
   *
   * @type {string}
   * @memberof GetConnectedAccountReadyResponse
   */
  message?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetConnectedAccountReadyResponse
   */
  stripeConnectedAccountReady?: boolean;
}

/**
 *
 * @export
 * @interface GetDeleteUserConfirmationLinkResponse
 */
export interface GetDeleteUserConfirmationLinkResponse {
  /**
   *
   * @type {string}
   * @memberof GetDeleteUserConfirmationLinkResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetDisposableAuthLinkResponse
 */
export interface GetDisposableAuthLinkResponse {
  /**
   *
   * @type {string}
   * @memberof GetDisposableAuthLinkResponse
   */
  authLink?: string;
  /**
   *
   * @type {string}
   * @memberof GetDisposableAuthLinkResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetFollowedUserIDsResponse
 */
export interface GetFollowedUserIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetFollowedUserIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetFollowedUserIDsResponse
   */
  userIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetIsPostUnlockedResponse
 */
export interface GetIsPostUnlockedResponse {
  /**
   *
   * @type {string}
   * @memberof GetIsPostUnlockedResponse
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof GetIsPostUnlockedResponse
   */
  unlockPrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetIsPostUnlockedResponse
   */
  unlocked?: boolean;
}

/**
 *
 * @export
 * @interface GetIsTrackBoostedResponse
 */
export interface GetIsTrackBoostedResponse {
  /**
   *
   * @type {boolean}
   * @memberof GetIsTrackBoostedResponse
   */
  boosted?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetIsTrackBoostedResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetIsTrackUnlockedResponse
 */
export interface GetIsTrackUnlockedResponse {
  /**
   *
   * @type {string}
   * @memberof GetIsTrackUnlockedResponse
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof GetIsTrackUnlockedResponse
   */
  unlockPrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetIsTrackUnlockedResponse
   */
  unlocked?: boolean;
}

/**
 *
 * @export
 * @interface GetLikedArtistsResponse
 */
export interface GetLikedArtistsResponse {
  /**
   *
   * @type {Array<GetLikedArtistsResponseArtist>}
   * @memberof GetLikedArtistsResponse
   */
  artists?: Array<GetLikedArtistsResponseArtist>;
  /**
   *
   * @type {string}
   * @memberof GetLikedArtistsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetLikedArtistsResponseArtist
 */
export interface GetLikedArtistsResponseArtist {
  /**
   *
   * @type {string}
   * @memberof GetLikedArtistsResponseArtist
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof GetLikedArtistsResponseArtist
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetLikedArtistsResponseArtist
   */
  isLiked?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetLikedArtistsResponseArtist
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GetLikedArtistsResponseArtist
   */
  username?: string;
}

/**
 *
 * @export
 * @interface GetLikedCommentIDsResponse
 */
export interface GetLikedCommentIDsResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetLikedCommentIDsResponse
   */
  commentIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GetLikedCommentIDsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetLikedPostIDsResponse
 */
export interface GetLikedPostIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetLikedPostIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetLikedPostIDsResponse
   */
  postIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetLikedPostsResponse
 */
export interface GetLikedPostsResponse {
  /**
   *
   * @type {string}
   * @memberof GetLikedPostsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<PostWithTracks>}
   * @memberof GetLikedPostsResponse
   */
  posts?: Array<PostWithTracks>;
}

/**
 *
 * @export
 * @interface GetLikedTrackIDsResponse
 */
export interface GetLikedTrackIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetLikedTrackIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetLikedTrackIDsResponse
   */
  trackIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetLikedTracksResponse
 */
export interface GetLikedTracksResponse {
  /**
   *
   * @type {string}
   * @memberof GetLikedTracksResponse
   */
  message?: string;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetLikedTracksResponse
   */
  tracks?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface GetNotificationsResponse
 */
export interface GetNotificationsResponse {
  /**
   *
   * @type {string}
   * @memberof GetNotificationsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<MainNotificationData>}
   * @memberof GetNotificationsResponse
   */
  notifications?: Array<MainNotificationData>;
}

/**
 *
 * @export
 * @interface GetPaymentTransactionsResponse
 */
export interface GetPaymentTransactionsResponse {
  /**
   *
   * @type {string}
   * @memberof GetPaymentTransactionsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<PaymentTransaction>}
   * @memberof GetPaymentTransactionsResponse
   */
  paymentTransactions?: Array<PaymentTransaction>;
}

/**
 *
 * @export
 * @interface GetPayoutTransactionsResponse
 */
export interface GetPayoutTransactionsResponse {
  /**
   *
   * @type {string}
   * @memberof GetPayoutTransactionsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<PayoutTransaction>}
   * @memberof GetPayoutTransactionsResponse
   */
  payoutTransactions?: Array<PayoutTransaction>;
}

/**
 *
 * @export
 * @interface GetPostResponse
 */
export interface GetPostResponse {
  /**
   *
   * @type {string}
   * @memberof GetPostResponse
   */
  message?: string;
  /**
   *
   * @type {PostWithTracks}
   * @memberof GetPostResponse
   */
  post?: PostWithTracks;
}

/**
 *
 * @export
 * @interface GetPostsResponse
 */
export interface GetPostsResponse {
  /**
   *
   * @type {Array<PostWithTracks>}
   * @memberof GetPostsResponse
   */
  posts?: Array<PostWithTracks>;
}

/**
 *
 * @export
 * @interface GetProfileTracksResponse
 */
export interface GetProfileTracksResponse {
  /**
   *
   * @type {string}
   * @memberof GetProfileTracksResponse
   */
  message?: string;
  /**
   *
   * @type {MainTracks}
   * @memberof GetProfileTracksResponse
   */
  tracks?: MainTracks;
}

/**
 *
 * @export
 * @interface GetReferralCodeResponse
 */
export interface GetReferralCodeResponse {
  /**
   *
   * @type {string}
   * @memberof GetReferralCodeResponse
   */
  code?: string;
}

/**
 *
 * @export
 * @interface GetReportMessagesResponse
 */
export interface GetReportMessagesResponse {
  /**
   *
   * @type {string}
   * @memberof GetReportMessagesResponse
   */
  message?: string;
  /**
   *
   * @type {Array<ReportMessageEnhanced>}
   * @memberof GetReportMessagesResponse
   */
  reportMessages?: Array<ReportMessageEnhanced>;
}

/**
 *
 * @export
 * @interface GetReportResponse
 */
export interface GetReportResponse {
  /**
   *
   * @type {string}
   * @memberof GetReportResponse
   */
  message?: string;
  /**
   *
   * @type {Report}
   * @memberof GetReportResponse
   */
  report?: Report;
}

/**
 *
 * @export
 * @interface GetReportsResponse
 */
export interface GetReportsResponse {
  /**
   *
   * @type {string}
   * @memberof GetReportsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<ReportListItem>}
   * @memberof GetReportsResponse
   */
  reports?: Array<ReportListItem>;
}

/**
 *
 * @export
 * @interface GetStatsResponse
 */
export interface GetStatsResponse {
  /**
   *
   * @type {string}
   * @memberof GetStatsResponse
   */
  link?: string;
  /**
   *
   * @type {GetStatsResponseStats}
   * @memberof GetStatsResponse
   */
  stats?: GetStatsResponseStats;
}

/**
 *
 * @export
 * @interface GetStatsResponseStats
 */
export interface GetStatsResponseStats {
  /**
   *
   * @type {number}
   * @memberof GetStatsResponseStats
   */
  opened?: number;
  /**
   *
   * @type {number}
   * @memberof GetStatsResponseStats
   */
  registered?: number;
  /**
   *
   * @type {number}
   * @memberof GetStatsResponseStats
   */
  subscribed?: number;
  /**
   *
   * @type {Array<GetStatsResponseTimelineData>}
   * @memberof GetStatsResponseStats
   */
  timeline?: Array<GetStatsResponseTimelineData>;
}

/**
 *
 * @export
 * @interface GetStatsResponseTimelineData
 */
export interface GetStatsResponseTimelineData {
  /**
   *
   * @type {number}
   * @memberof GetStatsResponseTimelineData
   */
  count?: number;
  /**
   *
   * @type {string}
   * @memberof GetStatsResponseTimelineData
   */
  date?: string;
}

/**
 *
 * @export
 * @interface GetSubscribedToArtistsResponse
 */
export interface GetSubscribedToArtistsResponse {
  /**
   *
   * @type {Array<GetSubscribedToArtistsResponseArtist>}
   * @memberof GetSubscribedToArtistsResponse
   */
  artists?: Array<GetSubscribedToArtistsResponseArtist>;
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToArtistsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetSubscribedToArtistsResponseArtist
 */
export interface GetSubscribedToArtistsResponseArtist {
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToArtistsResponseArtist
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToArtistsResponseArtist
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToArtistsResponseArtist
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToArtistsResponseArtist
   */
  username?: string;
}

/**
 *
 * @export
 * @interface GetSubscribedToIDsResponse
 */
export interface GetSubscribedToIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetSubscribedToIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetSubscribedToIDsResponse
   */
  subscribedToIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetSubscriptionResponse
 */
export interface GetSubscriptionResponse {
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionResponse
   */
  refreshUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionResponse
   */
  stripeChargesEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionResponse
   */
  stripePayoutsEnabled?: boolean;
  /**
   *
   * @type {ModelsArtistSubscriptionSettings}
   * @memberof GetSubscriptionResponse
   */
  subscription?: ModelsArtistSubscriptionSettings;
}

/**
 *
 * @export
 * @interface GetSubscriptionStatsResponse
 */
export interface GetSubscriptionStatsResponse {
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  balanceAvailable?: number;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  balancePending?: number;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  freeTrialDays?: number;
  /**
   *
   * @type {Array<GetSubscriptionStatsResponseSubscriber>}
   * @memberof GetSubscriptionStatsResponse
   */
  lastSubscribers?: Array<GetSubscriptionStatsResponseSubscriber>;
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionStatsResponse
   */
  pendingPayout?: boolean;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  subscriptionPrice?: number;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  subscriptionPriceAverage?: number;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponse
   */
  subscriptionUpperPriceLimit?: number;
}

/**
 *
 * @export
 * @interface GetSubscriptionStatsResponseSubscriber
 */
export interface GetSubscriptionStatsResponseSubscriber {
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatsResponseSubscriber
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatsResponseSubscriber
   */
  avatarUrl?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatsResponseSubscriber
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionStatsResponseSubscriber
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatsResponseSubscriber
   */
  subscriptionTime?: string;
}

/**
 *
 * @export
 * @interface GetSubscriptionStatusResponse
 */
export interface GetSubscriptionStatusResponse {
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatusResponse
   */
  message?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionStatusResponse
   */
  subscribed?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionStatusResponse
   */
  subscriptionStatus?: string;
}

/**
 *
 * @export
 * @interface GetSuggestedArtistsResponse
 */
export interface GetSuggestedArtistsResponse {
  /**
   *
   * @type {string}
   * @memberof GetSuggestedArtistsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<GetSuggestedArtistsResponseData>}
   * @memberof GetSuggestedArtistsResponse
   */
  suggestions?: Array<GetSuggestedArtistsResponseData>;
}

/**
 *
 * @export
 * @interface GetSuggestedArtistsResponseData
 */
export interface GetSuggestedArtistsResponseData {
  /**
   *
   * @type {boolean}
   * @memberof GetSuggestedArtistsResponseData
   */
  canSubscribeToUser?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetSuggestedArtistsResponseData
   */
  isLiked?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetSuggestedArtistsResponseData
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetSuggestedArtistsResponseData
   */
  userAvatarFireId?: string;
  /**
   *
   * @type {string}
   * @memberof GetSuggestedArtistsResponseData
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof GetSuggestedArtistsResponseData
   */
  userName?: string;
  /**
   *
   * @type {string}
   * @memberof GetSuggestedArtistsResponseData
   */
  userUsername?: string;
}

/**
 *
 * @export
 * @interface GetTipResponse
 */
export interface GetTipResponse {
  /**
   *
   * @type {string}
   * @memberof GetTipResponse
   */
  message?: string;
  /**
   *
   * @type {TipWithUser}
   * @memberof GetTipResponse
   */
  tip?: TipWithUser;
}

/**
 *
 * @export
 * @interface GetTipsResponse
 */
export interface GetTipsResponse {
  /**
   *
   * @type {Array<IncomeTip>}
   * @memberof GetTipsResponse
   */
  incomeTips?: Array<IncomeTip>;
  /**
   *
   * @type {string}
   * @memberof GetTipsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetTrackResponse
 */
export interface GetTrackResponse {
  /**
   *
   * @type {ExtendedTrack}
   * @memberof GetTrackResponse
   */
  track?: ExtendedTrack;
}

/**
 *
 * @export
 * @interface GetTracksResponse
 */
export interface GetTracksResponse {
  /**
   *
   * @type {string}
   * @memberof GetTracksResponse
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof GetTracksResponse
   */
  total?: number;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetTracksResponse
   */
  tracks?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface GetUnlockedPostsIDsResponse
 */
export interface GetUnlockedPostsIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetUnlockedPostsIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetUnlockedPostsIDsResponse
   */
  unlockedPostsIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetUnlockedPostsResponse
 */
export interface GetUnlockedPostsResponse {
  /**
   *
   * @type {string}
   * @memberof GetUnlockedPostsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<PostWithTracks>}
   * @memberof GetUnlockedPostsResponse
   */
  posts?: Array<PostWithTracks>;
}

/**
 *
 * @export
 * @interface GetUnlockedTracksIDsResponse
 */
export interface GetUnlockedTracksIDsResponse {
  /**
   *
   * @type {string}
   * @memberof GetUnlockedTracksIDsResponse
   */
  message?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetUnlockedTracksIDsResponse
   */
  unlockedTracksIds?: Array<string>;
}

/**
 *
 * @export
 * @interface GetUnlockedTracksResponse
 */
export interface GetUnlockedTracksResponse {
  /**
   *
   * @type {string}
   * @memberof GetUnlockedTracksResponse
   */
  message?: string;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof GetUnlockedTracksResponse
   */
  tracks?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface GetUnreadNotificationsCountResponse
 */
export interface GetUnreadNotificationsCountResponse {
  /**
   *
   * @type {string}
   * @memberof GetUnreadNotificationsCountResponse
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof GetUnreadNotificationsCountResponse
   */
  unreadNotificationsCount?: number;
}

/**
 *
 * @export
 * @interface GetUserCommentsResponse
 */
export interface GetUserCommentsResponse {
  /**
   *
   * @type {Array<ExtendedComment>}
   * @memberof GetUserCommentsResponse
   */
  comments?: Array<ExtendedComment>;
  /**
   *
   * @type {string}
   * @memberof GetUserCommentsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface GetUserResponse
 */
export interface GetUserResponse {
  /**
   *
   * @type {string}
   * @memberof GetUserResponse
   */
  message?: string;
  /**
   *
   * @type {GetUserResponseData}
   * @memberof GetUserResponse
   */
  user?: GetUserResponseData;
}

/**
 *
 * @export
 * @interface GetUserResponseData
 */
export interface GetUserResponseData {
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  activeAt?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof GetUserResponseData
   */
  apnsTokens?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof GetUserResponseData
   */
  artistLikesCount?: number;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  artistReferralCode?: string;
  /**
   * ArtistSubscribersCount uint  `json:\"artistSubscribersCount\" gorm:\"column:artistSubscribersCount\"` ArtistLikesCount       uint  `json:\"artistLikesCount\" gorm:\"column:artistLikesCount\"`
   * @type {number}
   * @memberof GetUserResponseData
   */
  artistSubscribersCount?: number;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  firebaseId?: string;
  /**
   *
   * @type {number}
   * @memberof GetUserResponseData
   */
  followingCount?: number;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  onboardingStage?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  stripeConnectedAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {number}
   * @memberof GetUserResponseData
   */
  subscribedToCount?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof GetUserResponseData
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserResponseData
   */
  username?: string;
}

/**
 *
 * @export
 * @interface GetUserSuggestionsData
 */
export interface GetUserSuggestionsData {
  /**
   *
   * @type {string}
   * @memberof GetUserSuggestionsData
   */
  avatarFileID?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserSuggestionsData
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserSuggestionsData
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUserSuggestionsData
   */
  username?: string;
}

/**
 *
 * @export
 * @interface GetUserSuggestionsResponse
 */
export interface GetUserSuggestionsResponse {
  /**
   *
   * @type {Array<GetUserSuggestionsData>}
   * @memberof GetUserSuggestionsResponse
   */
  users?: Array<GetUserSuggestionsData>;
}

/**
 *
 * @export
 * @interface GetUsernameAvailableResponse
 */
export interface GetUsernameAvailableResponse {
  /**
   *
   * @type {boolean}
   * @memberof GetUsernameAvailableResponse
   */
  usernameAvailable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetUsernameAvailableResponse
   */
  usernameValid?: boolean;
}

/**
 *
 * @export
 * @interface IOSIAPWebhookHandlerResponse
 */
export interface IOSIAPWebhookHandlerResponse {
  /**
   *
   * @type {string}
   * @memberof IOSIAPWebhookHandlerResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface IOSPostUnlockRequest
 */
export interface IOSPostUnlockRequest {
  /**
   *
   * @type {string}
   * @memberof IOSPostUnlockRequest
   */
  postId: string;
  /**
   *
   * @type {string}
   * @memberof IOSPostUnlockRequest
   */
  receipt: string;
}

/**
 *
 * @export
 * @interface IOSPostUnlockResponse
 */
export interface IOSPostUnlockResponse {
  /**
   *
   * @type {string}
   * @memberof IOSPostUnlockResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface IOSTrackBoostRequest
 */
export interface IOSTrackBoostRequest {
  /**
   *
   * @type {string}
   * @memberof IOSTrackBoostRequest
   */
  receipt: string;
  /**
   *
   * @type {string}
   * @memberof IOSTrackBoostRequest
   */
  trackId: string;
}

/**
 *
 * @export
 * @interface IOSTrackBoostResponse
 */
export interface IOSTrackBoostResponse {
  /**
   *
   * @type {string}
   * @memberof IOSTrackBoostResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface IOSTrackUnlockRequest
 */
export interface IOSTrackUnlockRequest {
  /**
   *
   * @type {string}
   * @memberof IOSTrackUnlockRequest
   */
  receipt: string;
  /**
   *
   * @type {string}
   * @memberof IOSTrackUnlockRequest
   */
  trackId: string;
}

/**
 *
 * @export
 * @interface IOSTrackUnlockResponse
 */
export interface IOSTrackUnlockResponse {
  /**
   *
   * @type {string}
   * @memberof IOSTrackUnlockResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface IncomeTip
 */
export interface IncomeTip {
  /**
   *
   * @type {number}
   * @memberof IncomeTip
   */
  tipAmount?: number;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  tipCreatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  tipId?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  tipMessage?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  tipStatus?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  userAvatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTip
   */
  userUsername?: string;
}

/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  idToken: string;
}

/**
 *
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
  /**
   *
   * @type {string}
   * @memberof LoginResponse
   */
  authToken?: string;
  /**
   *
   * @type {ModelsUser}
   * @memberof LoginResponse
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface MainCreateSetupPaymentCheckoutHandlerResponseBody
 */
export interface MainCreateSetupPaymentCheckoutHandlerResponseBody {
  /**
   *
   * @type {string}
   * @memberof MainCreateSetupPaymentCheckoutHandlerResponseBody
   */
  checkoutSessionId?: string;
}

/**
 *
 * @export
 * @interface MainNotificationData
 */
export interface MainNotificationData {
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  boldText?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  commentPostId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  commentTargetId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  event?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  postFileId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  postFileType?: string;
  /**
   *
   * @type {boolean}
   * @memberof MainNotificationData
   */
  read?: boolean;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  sourceUserId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  trackCoverFileId?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof MainNotificationData
   */
  userAvatarFileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof MainNotificationData
   */
  userUsernames?: Array<string>;
}

/**
 *
 * @export
 * @interface MainParentEntities
 */
export interface MainParentEntities {
  /**
   *
   * @type {string}
   * @memberof MainParentEntities
   */
  postId?: string;
}

/**
 *
 * @export
 * @interface MainReportTypesMap
 */
export interface MainReportTypesMap {
  [key: string]: number;
}

/**
 *
 * @export
 * @interface MainTracks
 */
export interface MainTracks {
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof MainTracks
   */
  exclusive?: Array<ExtendedTrack>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof MainTracks
   */
  latest?: Array<ExtendedTrack>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof MainTracks
   */
  popular?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface ModelsArtistSubscriptionSettings
 */
export interface ModelsArtistSubscriptionSettings {
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  artistUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  createdAt?: string;
  /**
   *
   * @type {number}
   * @memberof ModelsArtistSubscriptionSettings
   */
  freeTrialDays?: number;
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof ModelsArtistSubscriptionSettings
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  stripePriceId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  stripeProductId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsArtistSubscriptionSettings
   */
  updatedAt?: string;
}

/**
 *
 * @export
 * @interface ModelsTrack
 */
export interface ModelsTrack {
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  coverFileId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  name?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ModelsTrack
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  trackFileId?: string;
  /**
   *
   * @type {number}
   * @memberof ModelsTrack
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsTrack
   */
  visibility?: string;
}

/**
 *
 * @export
 * @interface ModelsUser
 */
export interface ModelsUser {
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  activeAt?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ModelsUser
   */
  apnsTokens?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  artistReferralCode?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  firebaseId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  onboardingStage?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  stripeConnectedAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ModelsUser
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsUser
   */
  username?: string;
}

/**
 *
 * @export
 * @interface PauseSubscriptionsRequest
 */
export interface PauseSubscriptionsRequest {
  /**
   *
   * @type {string}
   * @memberof PauseSubscriptionsRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface PauseSubscriptionsResponse
 */
export interface PauseSubscriptionsResponse {
  /**
   *
   * @type {string}
   * @memberof PauseSubscriptionsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface PaymentTransaction
 */
export interface PaymentTransaction {
  /**
   *
   * @type {number}
   * @memberof PaymentTransaction
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  availableOn?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof PaymentTransaction
   */
  fee?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  type?: string;
}

/**
 *
 * @export
 * @interface PayoutTransaction
 */
export interface PayoutTransaction {
  /**
   *
   * @type {number}
   * @memberof PayoutTransaction
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  arrivalDate?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  sourceType?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  statementDescriptor?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof PayoutTransaction
   */
  type?: string;
}

/**
 *
 * @export
 * @interface Post
 */
export interface Post {
  /**
   *
   * @type {string}
   * @memberof Post
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  fileId?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  fileType?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  text?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Post
   */
  trackIds?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof Post
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof Post
   */
  visibility?: string;
}

/**
 *
 * @export
 * @interface PostWithTracks
 */
export interface PostWithTracks {
  /**
   *
   * @type {number}
   * @memberof PostWithTracks
   */
  commentsCount?: number;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  fileId?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  fileType?: string;
  /**
   *
   * @type {boolean}
   * @memberof PostWithTracks
   */
  hasUserConnectedAccount?: boolean;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof PostWithTracks
   */
  isAuthorLiked?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PostWithTracks
   */
  isCommented?: boolean;
  /**
   *
   * @type {number}
   * @memberof PostWithTracks
   */
  likesCount?: number;
  /**
   *
   * @type {number}
   * @memberof PostWithTracks
   */
  subscriptionPrice?: number;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  text?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PostWithTracks
   */
  trackIds?: Array<string>;
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof PostWithTracks
   */
  tracks?: Array<ExtendedTrack>;
  /**
   *
   * @type {number}
   * @memberof PostWithTracks
   */
  unlockPrice?: number;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  userAvatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  userName?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  userUsername?: string;
  /**
   *
   * @type {string}
   * @memberof PostWithTracks
   */
  visibility?: string;
}

/**
 *
 * @export
 * @interface ReadNotificationsResponse
 */
export interface ReadNotificationsResponse {
  /**
   *
   * @type {string}
   * @memberof ReadNotificationsResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface RefreshTokenResponse
 */
export interface RefreshTokenResponse {
  /**
   *
   * @type {string}
   * @memberof RefreshTokenResponse
   */
  authToken?: string;
  /**
   *
   * @type {string}
   * @memberof RefreshTokenResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface RegisterFanRequest
 */
export interface RegisterFanRequest {
  /**
   *
   * @type {string}
   * @memberof RegisterFanRequest
   */
  idToken?: string;
  /**
   *
   * @type {string}
   * @memberof RegisterFanRequest
   */
  referralCode?: string;
  /**
   *
   * @type {RegisterFanRequestUserModel}
   * @memberof RegisterFanRequest
   */
  user?: RegisterFanRequestUserModel;
}

/**
 *
 * @export
 * @interface RegisterFanRequestUserModel
 */
export interface RegisterFanRequestUserModel {
  /**
   *
   * @type {string}
   * @memberof RegisterFanRequestUserModel
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof RegisterFanRequestUserModel
   */
  tags: Array<string>;
}

/**
 *
 * @export
 * @interface RegisterFanResponse
 */
export interface RegisterFanResponse {
  /**
   *
   * @type {string}
   * @memberof RegisterFanResponse
   */
  authToken?: string;
  /**
   *
   * @type {ModelsUser}
   * @memberof RegisterFanResponse
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
  /**
   *
   * @type {string}
   * @memberof RegisterRequest
   */
  idToken?: string;
  /**
   *
   * @type {RegisterRequestUserModel}
   * @memberof RegisterRequest
   */
  user?: RegisterRequestUserModel;
}

/**
 *
 * @export
 * @interface RegisterRequestUserModel
 */
export interface RegisterRequestUserModel {
  /**
   *
   * @type {string}
   * @memberof RegisterRequestUserModel
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RegisterRequestUserModel
   */
  role: string;
  /**
   *
   * @type {Array<string>}
   * @memberof RegisterRequestUserModel
   */
  tags: Array<string>;
  /**
   *
   * @type {string}
   * @memberof RegisterRequestUserModel
   */
  username: string;
}

/**
 *
 * @export
 * @interface RegisterResponse
 */
export interface RegisterResponse {
  /**
   *
   * @type {string}
   * @memberof RegisterResponse
   */
  authToken?: string;
  /**
   *
   * @type {ModelsUser}
   * @memberof RegisterResponse
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface Report
 */
export interface Report {
  /**
   *
   * @type {string}
   * @memberof Report
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  id?: string;
  /**
   * id of moderator that considered report (resolved, blocked)
   * @type {string}
   * @memberof Report
   */
  moderatorId?: string;
  /**
   * identifier
   * @type {string}
   * @memberof Report
   */
  shortId?: string;
  /**
   * report status
   * @type {string}
   * @memberof Report
   */
  status?: string;
  /**
   * id of reported entity
   * @type {string}
   * @memberof Report
   */
  targetId?: string;
  /**
   * type of reported entity
   * @type {string}
   * @memberof Report
   */
  targetType?: string;
  /**
   * user author of entity
   * @type {string}
   * @memberof Report
   */
  targetUserId?: string;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  updatedAt?: string;
}

/**
 *
 * @export
 * @interface ReportListItem
 */
export interface ReportListItem {
  /**
   *
   * @type {string}
   * @memberof ReportListItem
   */
  entityId?: string;
  /**
   * type of reported entity
   * @type {string}
   * @memberof ReportListItem
   */
  entityType?: string;
  /**
   *
   * @type {string}
   * @memberof ReportListItem
   */
  id?: string;
  /**
   *
   * @type {MainReportTypesMap}
   * @memberof ReportListItem
   */
  reportTypes?: MainReportTypesMap;
  /**
   *
   * @type {string}
   * @memberof ReportListItem
   */
  shortId?: string;
  /**
   * report status
   * @type {string}
   * @memberof ReportListItem
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ReportListItem
   */
  targetUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ReportListItem
   */
  targetUserUsername?: string;
}

/**
 *
 * @export
 * @interface ReportMessage
 */
export interface ReportMessage {
  /**
   *
   * @type {string}
   * @memberof ReportMessage
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessage
   */
  id?: string;
  /**
   * report message
   * @type {string}
   * @memberof ReportMessage
   */
  message?: string;
  /**
   * report id
   * @type {string}
   * @memberof ReportMessage
   */
  reportId?: string;
  /**
   * report type
   * @type {string}
   * @memberof ReportMessage
   */
  reportType?: string;
  /**
   * user that send report
   * @type {string}
   * @memberof ReportMessage
   */
  sourceUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessage
   */
  updatedAt?: string;
}

/**
 *
 * @export
 * @interface ReportMessageEnhanced
 */
export interface ReportMessageEnhanced {
  /**
   *
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  reportId?: string;
  /**
   * report type
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  reportType?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMessageEnhanced
   */
  sourceUserUsername?: string;
}

/**
 *
 * @export
 * @interface ResolveReportRequest
 */
export interface ResolveReportRequest {
  /**
   *
   * @type {string}
   * @memberof ResolveReportRequest
   */
  reportId: string;
}

/**
 *
 * @export
 * @interface ResolveReportResponse
 */
export interface ResolveReportResponse {
  /**
   *
   * @type {string}
   * @memberof ResolveReportResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface ReverseTransferRequest
 */
export interface ReverseTransferRequest {
  /**
   *
   * @type {number}
   * @memberof ReverseTransferRequest
   */
  reverseAmount?: number;
  /**
   *
   * @type {string}
   * @memberof ReverseTransferRequest
   */
  transferId: string;
}

/**
 *
 * @export
 * @interface ReverseTransferResponse
 */
export interface ReverseTransferResponse {
  /**
   *
   * @type {string}
   * @memberof ReverseTransferResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface SearchArtist
 */
export interface SearchArtist {
  /**
   *
   * @type {string}
   * @memberof SearchArtist
   */
  avatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof SearchArtist
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof SearchArtist
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof SearchArtist
   */
  streams?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchArtist
   */
  tags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchArtist
   */
  username?: string;
}

/**
 *
 * @export
 * @interface SearchArtistsResponse
 */
export interface SearchArtistsResponse {
  /**
   *
   * @type {Array<SearchArtist>}
   * @memberof SearchArtistsResponse
   */
  artists?: Array<SearchArtist>;
}

/**
 *
 * @export
 * @interface SearchTracksResponse
 */
export interface SearchTracksResponse {
  /**
   *
   * @type {Array<ExtendedTrack>}
   * @memberof SearchTracksResponse
   */
  tracks?: Array<ExtendedTrack>;
}

/**
 *
 * @export
 * @interface TipWithUser
 */
export interface TipWithUser {
  /**
   *
   * @type {string}
   * @memberof TipWithUser
   */
  tipAmount?: string;
  /**
   *
   * @type {string}
   * @memberof TipWithUser
   */
  tipMessage?: string;
  /**
   *
   * @type {string}
   * @memberof TipWithUser
   */
  userAvatarFileId?: string;
  /**
   *
   * @type {string}
   * @memberof TipWithUser
   */
  userName?: string;
}

/**
 *
 * @export
 * @interface UnlockPostRequest
 */
export interface UnlockPostRequest {
  /**
   *
   * @type {string}
   * @memberof UnlockPostRequest
   */
  postId: string;
  /**
   *
   * @type {string}
   * @memberof UnlockPostRequest
   */
  purchaseId: string;
  /**
   *
   * @type {string}
   * @memberof UnlockPostRequest
   */
  purchaseSource: string;
  /**
   *
   * @type {string}
   * @memberof UnlockPostRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface UnlockPostResponse
 */
export interface UnlockPostResponse {
  /**
   *
   * @type {string}
   * @memberof UnlockPostResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface UnlockTrackRequest
 */
export interface UnlockTrackRequest {
  /**
   *
   * @type {string}
   * @memberof UnlockTrackRequest
   */
  purchaseId: string;
  /**
   *
   * @type {string}
   * @memberof UnlockTrackRequest
   */
  purchaseSource: string;
  /**
   *
   * @type {string}
   * @memberof UnlockTrackRequest
   */
  trackId: string;
  /**
   *
   * @type {string}
   * @memberof UnlockTrackRequest
   */
  userId: string;
}

/**
 *
 * @export
 * @interface UnlockTrackResponse
 */
export interface UnlockTrackResponse {
  /**
   *
   * @type {string}
   * @memberof UnlockTrackResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface UpdateActivityResponse
 */
export interface UpdateActivityResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateActivityResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface UpdateSubscriptionPriceRequest
 */
export interface UpdateSubscriptionPriceRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateSubscriptionPriceRequest
   */
  price: number;
}

/**
 *
 * @export
 * @interface UpdateSubscriptionPriceResponse
 */
export interface UpdateSubscriptionPriceResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateSubscriptionPriceResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface UpdateTrackRequest
 */
export interface UpdateTrackRequest {
  /**
   *
   * @type {ModelsTrack}
   * @memberof UpdateTrackRequest
   */
  track?: ModelsTrack;
  /**
   *
   * @type {string}
   * @memberof UpdateTrackRequest
   */
  trackId: string;
}

/**
 *
 * @export
 * @interface UpdateTrackResponse
 */
export interface UpdateTrackResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateTrackResponse
   */
  message?: string;
  /**
   *
   * @type {ModelsTrack}
   * @memberof UpdateTrackResponse
   */
  track?: ModelsTrack;
}

/**
 *
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
  /**
   *
   * @type {ModelsUser}
   * @memberof UpdateUserRequest
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface UpdateUserResponse
 */
export interface UpdateUserResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateUserResponse
   */
  message?: string;
  /**
   *
   * @type {ModelsUser}
   * @memberof UpdateUserResponse
   */
  user?: ModelsUser;
}

/**
 *
 * @export
 * @interface UploadTrackCoverResponse
 */
export interface UploadTrackCoverResponse {
  /**
   *
   * @type {string}
   * @memberof UploadTrackCoverResponse
   */
  coverUrl?: string;
}

/**
 *
 * @export
 * @interface UploadTrackResponse
 */
export interface UploadTrackResponse {
  /**
   *
   * @type {ModelsTrack}
   * @memberof UploadTrackResponse
   */
  track?: ModelsTrack;
}

/**
 *
 * @export
 * @interface UploadUserAvatarResponse
 */
export interface UploadUserAvatarResponse {
  /**
   *
   * @type {string}
   * @memberof UploadUserAvatarResponse
   */
  avatarUrl?: string;
}

/**
 *
 * @export
 * @interface UserFile
 */
export interface UserFile {
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  bucket?: string;
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof UserFile
   */
  userId?: string;
}

/**
 *
 * @export
 * @interface WebGetMonetizationStatusResponse
 */
export interface WebGetMonetizationStatusResponse {
  /**
   *
   * @type {string}
   * @memberof WebGetMonetizationStatusResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof WebGetMonetizationStatusResponse
   */
  refreshUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof WebGetMonetizationStatusResponse
   */
  stripeChargesEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WebGetMonetizationStatusResponse
   */
  stripePayoutsEnabled?: boolean;
}

/**
 *
 * @export
 * @interface WebhookInvoicePaymentFailedResponse
 */
export interface WebhookInvoicePaymentFailedResponse {
  /**
   *
   * @type {string}
   * @memberof WebhookInvoicePaymentFailedResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface WebhookInvoicePaymentSucceededResponse
 */
export interface WebhookInvoicePaymentSucceededResponse {
  /**
   *
   * @type {string}
   * @memberof WebhookInvoicePaymentSucceededResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface WebhookSetupIntentSucceededResponse
 */
export interface WebhookSetupIntentSucceededResponse {
  /**
   *
   * @type {string}
   * @memberof WebhookSetupIntentSucceededResponse
   */
  message?: string;
}

/**
 *
 * @export
 * @interface WebhookTipPaymentIntentSucceededResponse
 */
export interface WebhookTipPaymentIntentSucceededResponse {
  /**
   *
   * @type {string}
   * @memberof WebhookTipPaymentIntentSucceededResponse
   */
  message?: string;
}

/**
 * DefaultApi - fetch parameter creator
 * @export
 */
export const DefaultApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Adds like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLike(targetId: string, type: string, options: any = {}): FetchArgs {
      // verify required parameter 'targetId' is not null or undefined
      if (targetId === null || targetId === undefined) {
        throw new RequiredError(
          "targetId",
          "Required parameter targetId was null or undefined when calling addLike."
        );
      }
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          "type",
          "Required parameter type was null or undefined when calling addLike."
        );
      }
      const localVarPath = `/likes`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (targetId !== undefined) {
        localVarQueryParameter["targetId"] = targetId;
      }

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Adds a new stream to track.
     * @param {AddStreamRequest} fields Track id to add a stream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTrackStream(fields: AddStreamRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling addTrackStream."
        );
      }
      const localVarPath = `/tracks/streams`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"AddStreamRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComment(fields: BlockCommentRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockComment."
        );
      }
      const localVarPath = `/comments/block`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockCommentRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks all comments related to user or post.
     * @param {BlockCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComments(fields: BlockCommentsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockComments."
        );
      }
      const localVarPath = `/comments/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockCommentsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks all notifications related to user or entity.
     * @param {BlockNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockNotifications(
      fields: BlockNotificationsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockNotifications."
        );
      }
      const localVarPath = `/notifications/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockNotificationsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPost(fields: BlockPostRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockPost."
        );
      }
      const localVarPath = `/posts/block`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockPostRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Block user posts and all related comments.
     * @param {BlockPostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPosts(fields: BlockPostsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockPosts."
        );
      }
      const localVarPath = `/posts/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockPostsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks all reports related to user.
     * @param {BlockReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockReports(fields: BlockReportsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockReports."
        );
      }
      const localVarPath = `/reports/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockReportsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Block user's tips in database.
     * @param {BlockTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTips(fields: BlockTipsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockTips."
        );
      }
      const localVarPath = `/tips/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockTipsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTrack(fields: BlockTrackRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockTrack."
        );
      }
      const localVarPath = `/tracks/block`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockTrackRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Block user's tracks in database.
     * @param {BlockTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTracks(fields: BlockTracksRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockTracks."
        );
      }
      const localVarPath = `/tracks/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockTracksRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockUser(fields: BlockUserRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling blockUser."
        );
      }
      const localVarPath = `/users/block`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BlockUserRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Boosts track.
     * @param {BoostTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boostTrack(fields: BoostTrackRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling boostTrack."
        );
      }
      const localVarPath = `/tracks/boost`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"BoostTrackRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to cancel subscription to artist.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription(
      fields: CancelSubscriptionRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling cancelSubscription."
        );
      }
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CancelSubscriptionRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Cancels stripe subscriptions based on provided user id.
     * @param {CancelSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscriptions(
      fields: CancelSubscriptionsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling cancelSubscriptions."
        );
      }
      const localVarPath = `/subscriptions/cancel`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CancelSubscriptionsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountRefresh(accountID: string, options: any = {}): FetchArgs {
      // verify required parameter 'accountID' is not null or undefined
      if (accountID === null || accountID === undefined) {
        throw new RequiredError(
          "accountID",
          "Required parameter accountID was null or undefined when calling connectedAccountRefresh."
        );
      }
      const localVarPath = `/subscriptions/connected/refresh`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accountID !== undefined) {
        localVarQueryParameter["accountID"] = accountID;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountReturn(accountID: string, options: any = {}): FetchArgs {
      // verify required parameter 'accountID' is not null or undefined
      if (accountID === null || accountID === undefined) {
        throw new RequiredError(
          "accountID",
          "Required parameter accountID was null or undefined when calling connectedAccountReturn."
        );
      }
      const localVarPath = `/subscriptions/connected/return`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accountID !== undefined) {
        localVarQueryParameter["accountID"] = accountID;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates subscription to artist.
     * @param {CreateArtistSubscriptionRequest} fields Artist ID to subscribe.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createArtistSubscription(
      fields: CreateArtistSubscriptionRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createArtistSubscription."
        );
      }
      const localVarPath = `/subscriptions/deprecated`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateArtistSubscriptionRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a comment.
     * @param {CreateCommentRequest} fields Information for creating comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComment(fields: CreateCommentRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createComment."
        );
      }
      const localVarPath = `/comments`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateCommentRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates connected account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnectedAccount(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/connected`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile(options: any = {}): FetchArgs {
      const localVarPath = `/files`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a notification.
     * @param {CreateNotificationRequestBody} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNotification(
      fields: CreateNotificationRequestBody,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createNotification."
        );
      }
      const localVarPath = `/notifications`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateNotificationRequestBody" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates Stripe Payment account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentAccount(options: any = {}): FetchArgs {
      const localVarPath = `/payments/account/dpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates Stripe Payment payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentPayout(options: any = {}): FetchArgs {
      const localVarPath = `/payments/payout/dpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates payout from stripe to artists bank account.
     * @param {CreatePayoutRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPayout(fields: CreatePayoutRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createPayout."
        );
      }
      const localVarPath = `/payments/payout`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreatePayoutRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a post.
     * @param {CreatePostRequest} fields Post information to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPost(fields: CreatePostRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createPost."
        );
      }
      const localVarPath = `/posts`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreatePostRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a report.
     * @param {CreateReportRequest} fields Information for creating report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createReport(fields: CreateReportRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createReport."
        );
      }
      const localVarPath = `/reports`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateReportRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates setup payment checkout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSetupPaymentCheckout(options: any = {}): FetchArgs {
      const localVarPath = `/payments/checkout`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates subscription to an artist.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubscription(
      fields: CreateSubscriptionRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createSubscription."
        );
      }
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateSubscriptionRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTip(fields: CreateTipRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createTip."
        );
      }
      const localVarPath = `/tips`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateTipRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates track object and stores it in database.
     * @param {CreateTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTrack(fields: CreateTrackRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createTrack."
        );
      }
      const localVarPath = `/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateTrackRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates transfer from platform to artist connected account.
     * @param {CreateTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransfer(
      fields: CreateTransferRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling createTransfer."
        );
      }
      const localVarPath = `/payments/transfer`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateTransferRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComment(commentId: string, options: any = {}): FetchArgs {
      // verify required parameter 'commentId' is not null or undefined
      if (commentId === null || commentId === undefined) {
        throw new RequiredError(
          "commentId",
          "Required parameter commentId was null or undefined when calling deleteComment."
        );
      }
      const localVarPath = `/comments`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (commentId !== undefined) {
        localVarQueryParameter["commentId"] = commentId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently deletes user's comments and all sub-comments from the platform.
     * @param {DeleteCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComments(
      fields: DeleteCommentsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteComments."
        );
      }
      const localVarPath = `/comments/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteCommentsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes a file based on provided id, fileId for new files, objectId for old files.
     * @param {DeleteFileRequest} fields options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(fields: DeleteFileRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteFile."
        );
      }
      const localVarPath = `/files`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteFileRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes user's firebase profile entirely.
     * @param {DeleteFirebaseProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFirebaseProfile(
      fields: DeleteFirebaseProfileRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteFirebaseProfile."
        );
      }
      const localVarPath = `/auth/firebase`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteFirebaseProfileRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete all purchases related to user or single purchase by id.
     * @param {DeleteIOSPurchasesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteIOSPurchases(
      fields: DeleteIOSPurchasesRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteIOSPurchases."
        );
      }
      const localVarPath = `/purchases/ios`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteIOSPurchasesRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLike(targetId: string, type: string, options: any = {}): FetchArgs {
      // verify required parameter 'targetId' is not null or undefined
      if (targetId === null || targetId === undefined) {
        throw new RequiredError(
          "targetId",
          "Required parameter targetId was null or undefined when calling deleteLike."
        );
      }
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          "type",
          "Required parameter type was null or undefined when calling deleteLike."
        );
      }
      const localVarPath = `/likes`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (targetId !== undefined) {
        localVarQueryParameter["targetId"] = targetId;
      }

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes notification by provided id.
     * @param {DeleteNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotification(
      fields: DeleteNotificationRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteNotification."
        );
      }
      const localVarPath = `/notifications`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteNotificationRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationByTermRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotificationByTerm(
      fields: DeleteNotificationByTermRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteNotificationByTerm."
        );
      }
      const localVarPath = `/notifications/by-term`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteNotificationByTermRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotifications(
      fields: DeleteNotificationsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteNotifications."
        );
      }
      const localVarPath = `/notifications/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteNotificationsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentMethod(options: any = {}): FetchArgs {
      const localVarPath = `/payments/payment-method`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePost(postId: string, options: any = {}): FetchArgs {
      // verify required parameter 'postId' is not null or undefined
      if (postId === null || postId === undefined) {
        throw new RequiredError(
          "postId",
          "Required parameter postId was null or undefined when calling deletePost."
        );
      }
      const localVarPath = `/posts`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (postId !== undefined) {
        localVarQueryParameter["postId"] = postId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently deletes user's posts and all related comments and media data.
     * @param {DeletePostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePosts(fields: DeletePostsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deletePosts."
        );
      }
      const localVarPath = `/posts/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeletePostsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently deletes user's reports from the platform.
     * @param {DeleteReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteReports(fields: DeleteReportsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteReports."
        );
      }
      const localVarPath = `/reports/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteReportsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes stripe connected account by provided id.
     * @param {DeleteStripeConnectedAccountRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeConnectedAccount(
      fields: DeleteStripeConnectedAccountRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteStripeConnectedAccount."
        );
      }
      const localVarPath = `/subscriptions/connected/delete`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteStripeConnectedAccountRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes stripe customer by provided id.
     * @param {DeleteStripeCustomerRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeCustomer(
      fields: DeleteStripeCustomerRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteStripeCustomer."
        );
      }
      const localVarPath = `/subscriptions/customer/delete`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteStripeCustomerRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes stripe entities from artist subscription settings based on provided user id.
     * @param {DeleteStripeEntitiesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeEntities(
      fields: DeleteStripeEntitiesRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteStripeEntities."
        );
      }
      const localVarPath = `/subscriptions/entities`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteStripeEntitiesRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently deletes user's tips entities from the platform.
     * @param {DeleteTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTips(fields: DeleteTipsRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteTips."
        );
      }
      const localVarPath = `/tips/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteTipsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Removes track from Storage and database.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTrack(trackId: string, options: any = {}): FetchArgs {
      // verify required parameter 'trackId' is not null or undefined
      if (trackId === null || trackId === undefined) {
        throw new RequiredError(
          "trackId",
          "Required parameter trackId was null or undefined when calling deleteTrack."
        );
      }
      const localVarPath = `/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (trackId !== undefined) {
        localVarQueryParameter["track_id"] = trackId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently deletes user's tracks from the platform.
     * @param {DeleteTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTracks(fields: DeleteTracksRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteTracks."
        );
      }
      const localVarPath = `/tracks/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteTracksRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes user and all user's data from the platform.
     * @param {DeleteUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(fields: DeleteUserRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling deleteUser."
        );
      }
      const localVarPath = `/users`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"DeleteUserRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Exchanges disposable auth code for Ryddm API auth token.
     * @param {ExchangeDisposableAuthCodeRequest} fields Disposable auth code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeDisposableAuthCode(
      fields: ExchangeDisposableAuthCodeRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling exchangeDisposableAuthCode."
        );
      }
      const localVarPath = `/auth/exchange-auth-code`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"ExchangeDisposableAuthCodeRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Verify and exchange firebase id token with auth token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeToken(fields: ExchangeTokenRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling exchangeToken."
        );
      }
      const localVarPath = `/auth/exchange`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"ExchangeTokenRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generates connected account link.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateConnectedAccountLink(userId: string, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling generateConnectedAccountLink."
        );
      }
      const localVarPath = `/subscriptions/connected/link`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves user's available and pending balances.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBalance(options: any = {}): FetchArgs {
      const localVarPath = `/payments/balance`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoostedTracks(options: any = {}): FetchArgs {
      const localVarPath = `/tracks/boosted`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {boolean} [exclusiveOnly]
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {Array<string>} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChartTracks(
      exclusiveOnly?: boolean,
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      tags?: Array<string>,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/charts/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (exclusiveOnly !== undefined) {
        localVarQueryParameter["exclusiveOnly"] = exclusiveOnly;
      }

      if (extend) {
        localVarQueryParameter["extend"] = extend;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (tags) {
        localVarQueryParameter["tags"] = tags;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComment(commentId: string, options: any = {}): FetchArgs {
      // verify required parameter 'commentId' is not null or undefined
      if (commentId === null || commentId === undefined) {
        throw new RequiredError(
          "commentId",
          "Required parameter commentId was null or undefined when calling getComment."
        );
      }
      const localVarPath = `/comments/comment`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (commentId !== undefined) {
        localVarQueryParameter["commentId"] = commentId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} targetId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComments(
      targetId: string,
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'targetId' is not null or undefined
      if (targetId === null || targetId === undefined) {
        throw new RequiredError(
          "targetId",
          "Required parameter targetId was null or undefined when calling getComments."
        );
      }
      const localVarPath = `/comments`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (targetId !== undefined) {
        localVarQueryParameter["targetId"] = targetId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns stripe connected account ready flag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnectedAccountReady(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/connected/account-ready`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Sends email with confirmation link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeleteUserConfirmationLink(options: any = {}): FetchArgs {
      const localVarPath = `/users/get-delete-confirmation-link`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generates disposable auth link.
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDisposableAuthLink(redirectUrl?: string, options: any = {}): FetchArgs {
      const localVarPath = `/auth/get-disposable-link`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (redirectUrl !== undefined) {
        localVarQueryParameter["redirectUrl"] = redirectUrl;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a file.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFile(fileId: string, options: any = {}): FetchArgs {
      // verify required parameter 'fileId' is not null or undefined
      if (fileId === null || fileId === undefined) {
        throw new RequiredError(
          "fileId",
          "Required parameter fileId was null or undefined when calling getFile."
        );
      }
      const localVarPath = `/files`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fileId !== undefined) {
        localVarQueryParameter["fileId"] = fileId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of followed by the user users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFollowedUserIDs(options: any = {}): FetchArgs {
      const localVarPath = `/users/followed-ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Checks if post is already unlocked.
     * @param {string} postId
     * @param {string} sourceUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsPostUnlocked(
      postId: string,
      sourceUserId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'postId' is not null or undefined
      if (postId === null || postId === undefined) {
        throw new RequiredError(
          "postId",
          "Required parameter postId was null or undefined when calling getIsPostUnlocked."
        );
      }
      // verify required parameter 'sourceUserId' is not null or undefined
      if (sourceUserId === null || sourceUserId === undefined) {
        throw new RequiredError(
          "sourceUserId",
          "Required parameter sourceUserId was null or undefined when calling getIsPostUnlocked."
        );
      }
      const localVarPath = `/posts/is-unlocked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (postId !== undefined) {
        localVarQueryParameter["postId"] = postId;
      }

      if (sourceUserId !== undefined) {
        localVarQueryParameter["sourceUserId"] = sourceUserId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Checks if track is boosted and boost duration still going.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackBoosted(trackId: string, options: any = {}): FetchArgs {
      // verify required parameter 'trackId' is not null or undefined
      if (trackId === null || trackId === undefined) {
        throw new RequiredError(
          "trackId",
          "Required parameter trackId was null or undefined when calling getIsTrackBoosted."
        );
      }
      const localVarPath = `/tracks/is-boosted`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (trackId !== undefined) {
        localVarQueryParameter["trackId"] = trackId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Checks if track is already unlocked.
     * @param {string} sourceUserId
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackUnlocked(
      sourceUserId: string,
      trackId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sourceUserId' is not null or undefined
      if (sourceUserId === null || sourceUserId === undefined) {
        throw new RequiredError(
          "sourceUserId",
          "Required parameter sourceUserId was null or undefined when calling getIsTrackUnlocked."
        );
      }
      // verify required parameter 'trackId' is not null or undefined
      if (trackId === null || trackId === undefined) {
        throw new RequiredError(
          "trackId",
          "Required parameter trackId was null or undefined when calling getIsTrackUnlocked."
        );
      }
      const localVarPath = `/tracks/is-unlocked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (sourceUserId !== undefined) {
        localVarQueryParameter["sourceUserId"] = sourceUserId;
      }

      if (trackId !== undefined) {
        localVarQueryParameter["trackId"] = trackId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns artists followed by user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling getLikedArtists."
        );
      }
      const localVarPath = `/likes/artists`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedCommentIDs(options: any = {}): FetchArgs {
      const localVarPath = `/comments/liked-ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPostIDs(options: any = {}): FetchArgs {
      const localVarPath = `/posts/posts-ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of posts liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/posts/liked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user track ids .
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTrackIDs(options: any = {}): FetchArgs {
      const localVarPath = `/tracks/liked-ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of tracks liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/tracks/liked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of notifications.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/notifications`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentMethod(options: any = {}): FetchArgs {
      const localVarPath = `/payments/payment-method`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of recent payments from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/payments/payment/transactions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (endingBefore !== undefined) {
        localVarQueryParameter["endingBefore"] = endingBefore;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (startingAfter !== undefined) {
        localVarQueryParameter["startingAfter"] = startingAfter;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of recent payouts from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayoutTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/payments/payout/transactions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (endingBefore !== undefined) {
        localVarQueryParameter["endingBefore"] = endingBefore;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (startingAfter !== undefined) {
        localVarQueryParameter["startingAfter"] = startingAfter;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a post by id.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPost(postId: string, options: any = {}): FetchArgs {
      // verify required parameter 'postId' is not null or undefined
      if (postId === null || postId === undefined) {
        throw new RequiredError(
          "postId",
          "Required parameter postId was null or undefined when calling getPost."
        );
      }
      const localVarPath = `/posts/post`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (postId !== undefined) {
        localVarQueryParameter["postId"] = postId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a post.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'personal' | 'popular' | 'username'} [type]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosts(
      limit?: number,
      offset?: number,
      type?: "personal" | "popular" | "username",
      userUsername?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/posts`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      if (userUsername !== undefined) {
        localVarQueryParameter["userUsername"] = userUsername;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns the list of tracks for artist profile.
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfileTracks(
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      userUsername?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/tracks/profile`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (extend) {
        localVarQueryParameter["extend"] = extend;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (userUsername !== undefined) {
        localVarQueryParameter["userUsername"] = userUsername;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns artist's referral code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReferralCode(options: any = {}): FetchArgs {
      const localVarPath = `/referral/code`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns status of report by provided id.
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport(reportId: string, options: any = {}): FetchArgs {
      // verify required parameter 'reportId' is not null or undefined
      if (reportId === null || reportId === undefined) {
        throw new RequiredError(
          "reportId",
          "Required parameter reportId was null or undefined when calling getReport."
        );
      }
      const localVarPath = `/reports/one`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (reportId !== undefined) {
        localVarQueryParameter["reportId"] = reportId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns messages related to certain report.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportMessages(
      reportId: string,
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'reportId' is not null or undefined
      if (reportId === null || reportId === undefined) {
        throw new RequiredError(
          "reportId",
          "Required parameter reportId was null or undefined when calling getReportMessages."
        );
      }
      const localVarPath = `/reports/report-messages`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (reportId !== undefined) {
        localVarQueryParameter["reportId"] = reportId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of reports.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReports(limit?: number, offset?: number, options: any = {}): FetchArgs {
      const localVarPath = `/reports`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns artist referral stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStats(options: any = {}): FetchArgs {
      const localVarPath = `/referral/stats`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns artists the user is subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling getSubscribedToArtists."
        );
      }
      const localVarPath = `/subscriptions/artists`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of user ids source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToIDs(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/artist-ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns subscription settings.
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(userId?: string, options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns subscription stats.
     * @param {number} lastSubscribersCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStats(
      lastSubscribersCount: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'lastSubscribersCount' is not null or undefined
      if (lastSubscribersCount === null || lastSubscribersCount === undefined) {
        throw new RequiredError(
          "lastSubscribersCount",
          "Required parameter lastSubscribersCount was null or undefined when calling getSubscriptionStats."
        );
      }
      const localVarPath = `/subscriptions/stats`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (lastSubscribersCount !== undefined) {
        localVarQueryParameter["lastSubscribersCount"] = lastSubscribersCount;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns subscription status.
     * @param {string} artistId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStatus(artistId: string, options: any = {}): FetchArgs {
      // verify required parameter 'artistId' is not null or undefined
      if (artistId === null || artistId === undefined) {
        throw new RequiredError(
          "artistId",
          "Required parameter artistId was null or undefined when calling getSubscriptionStatus."
        );
      }
      const localVarPath = `/subscriptions/status`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (artistId !== undefined) {
        localVarQueryParameter["artistId"] = artistId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Finds and returns suggested artist profiles.
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuggestedArtists(limit?: number, options: any = {}): FetchArgs {
      const localVarPath = `/users/suggestions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a tip by id.
     * @param {string} tipId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTip(tipId: string, options: any = {}): FetchArgs {
      // verify required parameter 'tipId' is not null or undefined
      if (tipId === null || tipId === undefined) {
        throw new RequiredError(
          "tipId",
          "Required parameter tipId was null or undefined when calling getTip."
        );
      }
      const localVarPath = `/tips/tip`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (tipId !== undefined) {
        localVarQueryParameter["tipId"] = tipId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find and return users income tip entries.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTips(limit?: number, offset?: number, options: any = {}): FetchArgs {
      const localVarPath = `/tips`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns track by provided id.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrack(trackId: string, options: any = {}): FetchArgs {
      // verify required parameter 'trackId' is not null or undefined
      if (trackId === null || trackId === undefined) {
        throw new RequiredError(
          "trackId",
          "Required parameter trackId was null or undefined when calling getTrack."
        );
      }
      const localVarPath = `/tracks/track`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (trackId !== undefined) {
        localVarQueryParameter["trackId"] = trackId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {string} [userId]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTracks(
      limit?: number,
      offset?: number,
      search?: string,
      userId?: string,
      userUsername?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (userId !== undefined) {
        localVarQueryParameter["user_id"] = userId;
      }

      if (userUsername !== undefined) {
        localVarQueryParameter["user_username"] = userUsername;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of posts unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/posts/unlocked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of unlocked by the user posts ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPostsIDs(options: any = {}): FetchArgs {
      const localVarPath = `/posts/unlock/ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of tracks unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/tracks/unlocked`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns a list of unlocked by the user tracks ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracksIDs(options: any = {}): FetchArgs {
      const localVarPath = `/tracks/unlock/ids`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns count of unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnreadNotificationsCount(options: any = {}): FetchArgs {
      const localVarPath = `/notifications/unread-count`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Finds and returns user by user id.
     * @param {Array<string>} [extend]
     * @param {string} [userId] UserID       string           &#x60;form:\&quot;userId\&quot;       json:\&quot;userId\&quot;       url:\&quot;userId\&quot; binding:\&quot;-\&quot;&#x60; UserUsername string           &#x60;form:\&quot;userUsername\&quot; json:\&quot;userUsername\&quot; url:\&quot;userUsername\&quot; binding:\&quot;-\&quot;&#x60;
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      extend?: Array<string>,
      userId?: string,
      userUsername?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/users`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (extend) {
        localVarQueryParameter["extend"] = extend;
      }

      if (userId !== undefined) {
        localVarQueryParameter["user_id"] = userId;
      }

      if (userUsername !== undefined) {
        localVarQueryParameter["user_username"] = userUsername;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Return a list of user comments (admins only).
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserComments(
      userId: string,
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling getUserComments."
        );
      }
      const localVarPath = `/comments/list`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets user deletion instruction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDeletionInstructions(options: any = {}): FetchArgs {
      const localVarPath = `/users/get-user-deletion-instructions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns user suggestions by username.
     * @param {string} searchUsername
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSuggestions(
      searchUsername: string,
      limit?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'searchUsername' is not null or undefined
      if (searchUsername === null || searchUsername === undefined) {
        throw new RequiredError(
          "searchUsername",
          "Required parameter searchUsername was null or undefined when calling getUserSuggestions."
        );
      }
      const localVarPath = `/search/suggestions/users`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (searchUsername !== undefined) {
        localVarQueryParameter["searchUsername"] = searchUsername;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Checks if given username is available for registration.
     * @param {string} username Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsernameAvailable(username: string, options: any = {}): FetchArgs {
      // verify required parameter 'username' is not null or undefined
      if (username === null || username === undefined) {
        throw new RequiredError(
          "username",
          "Required parameter username was null or undefined when calling getUsernameAvailable."
        );
      }
      const localVarPath = `/auth/username-available/{Username}`.replace(
        `{${"Username"}}`,
        encodeURIComponent(String(username))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles IOS IAP server-to-server notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSIAPWebhook(options: any = {}): FetchArgs {
      const localVarPath = `/purchases/ios/webhook`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlocks post in ios.
     * @param {IOSPostUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSPostUnlock(fields: IOSPostUnlockRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling iOSPostUnlock."
        );
      }
      const localVarPath = `/purchases/ios/post/unlock`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"IOSPostUnlockRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Boosts track in ios.
     * @param {IOSTrackBoostRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackBoost(fields: IOSTrackBoostRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling iOSTrackBoost."
        );
      }
      const localVarPath = `/purchases/ios/track/boost`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"IOSTrackBoostRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlocks track in ios.
     * @param {IOSTrackUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackUnlock(
      fields: IOSTrackUnlockRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling iOSTrackUnlock."
        );
      }
      const localVarPath = `/purchases/ios/track/unlock`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"IOSTrackUnlockRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Finds and returns all user's liked track IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    likesGET(options: any = {}): FetchArgs {
      const localVarPath = `/likes`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {LoginRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(fields: LoginRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling login."
        );
      }
      const localVarPath = `/auth/login`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"LoginRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Pauses stripe subscriptions based on provided user id.
     * @param {PauseSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pauseSubscriptions(
      fields: PauseSubscriptionsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling pauseSubscriptions."
        );
      }
      const localVarPath = `/subscriptions/pause`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"PauseSubscriptionsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountrefreshGET(accountID: string, options: any = {}): FetchArgs {
      // verify required parameter 'accountID' is not null or undefined
      if (accountID === null || accountID === undefined) {
        throw new RequiredError(
          "accountID",
          "Required parameter accountID was null or undefined when calling paymentsaccountrefreshGET."
        );
      }
      const localVarPath = `/payments/account/refresh/dpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accountID !== undefined) {
        localVarQueryParameter["accountID"] = accountID;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountreturnGET(accountID: string, options: any = {}): FetchArgs {
      // verify required parameter 'accountID' is not null or undefined
      if (accountID === null || accountID === undefined) {
        throw new RequiredError(
          "accountID",
          "Required parameter accountID was null or undefined when calling paymentsaccountreturnGET."
        );
      }
      const localVarPath = `/payments/account/return/dpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accountID !== undefined) {
        localVarQueryParameter["accountID"] = accountID;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `checkout.session.completed` stripe event and deletes all old user cards.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhookscheckoutSessionCompletedPOST(options: any = {}): FetchArgs {
      const localVarPath = `/payments/webhooks/checkout-session-completed`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhooksinvoicePaymentFailedPOST(options: any = {}): FetchArgs {
      const localVarPath = `/payments/webhooks/invoice-payment-failed/dpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Pings microservice.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping(options: any = {}): FetchArgs {
      const localVarPath = `/auth/ping`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reads notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readNotifications(options: any = {}): FetchArgs {
      const localVarPath = `/notifications/read`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Verify and prolong users auth token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options: any = {}): FetchArgs {
      const localVarPath = `/auth/refresh`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(fields: RegisterRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling register."
        );
      }
      const localVarPath = `/auth/register`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"RegisterRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterFanRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerFan(fields: RegisterFanRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling registerFan."
        );
      }
      const localVarPath = `/auth/register/fan`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"RegisterFanRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resolves the reports related to passed report id.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveReport(fields: ResolveReportRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling resolveReport."
        );
      }
      const localVarPath = `/reports`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"ResolveReportRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reverse previously created transfer from platform to artist connected account.
     * @param {ReverseTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reverseTransfer(
      fields: ReverseTransferRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling reverseTransfer."
        );
      }
      const localVarPath = `/payments/transfer/reverse`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"ReverseTransferRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchArtists(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/search/artists`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/search/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `customer.subscription.deleted` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionswebhookssubscriptionDeletedPOST(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/webhooks/subscription-deleted`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlocks post.
     * @param {UnlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockPost(fields: UnlockPostRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling unlockPost."
        );
      }
      const localVarPath = `/posts/unlock`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UnlockPostRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlocks track.
     * @param {UnlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockTrack(fields: UnlockTrackRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling unlockTrack."
        );
      }
      const localVarPath = `/tracks/unlock`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UnlockTrackRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates user activity time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateActivityTime(options: any = {}): FetchArgs {
      const localVarPath = `/users/activity`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates subscription.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates subscription price.
     * @param {UpdateSubscriptionPriceRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscriptionPrice(
      fields: UpdateSubscriptionPriceRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling updateSubscriptionPrice."
        );
      }
      const localVarPath = `/subscriptions/connected/price`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateSubscriptionPriceRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates track by track id.
     * @param {UpdateTrackRequest} fields Track information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTrack(fields: UpdateTrackRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling updateTrack."
        );
      }
      const localVarPath = `/tracks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateTrackRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the current user.
     * @param {UpdateUserRequest} fields User information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(fields: UpdateUserRequest, options: any = {}): FetchArgs {
      // verify required parameter 'fields' is not null or undefined
      if (fields === null || fields === undefined) {
        throw new RequiredError(
          "fields",
          "Required parameter fields was null or undefined when calling updateUser."
        );
      }
      const localVarPath = `/users`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateUserRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(fields || {})
        : fields || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Uploads the track to Google Cloud Storage.
     * @param {any} track Track to upload.
     * @param {any} cover Track cover to upload.
     * @param {string} name Track name (title).
     * @param {Array<string>} tags Track tags.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrack(
      track: any,
      cover: any,
      name: string,
      tags: Array<string>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'track' is not null or undefined
      if (track === null || track === undefined) {
        throw new RequiredError(
          "track",
          "Required parameter track was null or undefined when calling uploadTrack."
        );
      }
      // verify required parameter 'cover' is not null or undefined
      if (cover === null || cover === undefined) {
        throw new RequiredError(
          "cover",
          "Required parameter cover was null or undefined when calling uploadTrack."
        );
      }
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          "name",
          "Required parameter name was null or undefined when calling uploadTrack."
        );
      }
      // verify required parameter 'tags' is not null or undefined
      if (tags === null || tags === undefined) {
        throw new RequiredError(
          "tags",
          "Required parameter tags was null or undefined when calling uploadTrack."
        );
      }
      const localVarPath = `/tracks/upload`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new url.URLSearchParams();

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (track !== undefined) {
        localVarFormParams.set("track", track as any);
      }

      if (cover !== undefined) {
        localVarFormParams.set("cover", cover as any);
      }

      if (name !== undefined) {
        localVarFormParams.set("name", name as any);
      }

      if (tags) {
        tags.forEach((element) => {
          localVarFormParams.append("tags", element as any);
        });
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      localVarRequestOptions.body = localVarFormParams.toString();

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Uploads the track cover to Google Cloud Storage.
     * @param {any} cover Cover to upload.
     * @param {string} trackID Track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrackCover(
      cover: any,
      trackID: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'cover' is not null or undefined
      if (cover === null || cover === undefined) {
        throw new RequiredError(
          "cover",
          "Required parameter cover was null or undefined when calling uploadTrackCover."
        );
      }
      // verify required parameter 'trackID' is not null or undefined
      if (trackID === null || trackID === undefined) {
        throw new RequiredError(
          "trackID",
          "Required parameter trackID was null or undefined when calling uploadTrackCover."
        );
      }
      const localVarPath = `/tracks/cover/:TrackID`.replace(
        `{${"TrackID"}}`,
        encodeURIComponent(String(trackID))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new url.URLSearchParams();

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (cover !== undefined) {
        localVarFormParams.set("cover", cover as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      localVarRequestOptions.body = localVarFormParams.toString();

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Uploads user avatar to Google Cloud Storage.
     * @param {any} avatar User avatar to upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadUserAvatar(avatar: any, options: any = {}): FetchArgs {
      // verify required parameter 'avatar' is not null or undefined
      if (avatar === null || avatar === undefined) {
        throw new RequiredError(
          "avatar",
          "Required parameter avatar was null or undefined when calling uploadUserAvatar."
        );
      }
      const localVarPath = `/users/avatar`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new url.URLSearchParams();

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (avatar !== undefined) {
        localVarFormParams.set("avatar", avatar as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      localVarRequestOptions.body = localVarFormParams.toString();

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Returns monetization info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webGetMonetizationStatus(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/web/monetization/status`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event and sets subscription status to 'payment_failed'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentFailed(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/webhooks/invoice-payment-failed`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_succeeded` stripe event and sets subscription status to 'active'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentSucceeded(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/webhooks/invoice-payment-succeeded`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `setup_intent.succeeded` stripe event and creates subscription in stripe and database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookSetupIntentSucceeded(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/webhooks/setup-intent-succeeded`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Handles `payment_intent.succeeded` stripe event and sets tip status to 'paid'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookTipPaymentIntentSucceeded(options: any = {}): FetchArgs {
      const localVarPath = `/tips/webhooks/payment-intent-succeeded`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Adds like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLike(
      targetId: string,
      type: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).addLike(targetId, type, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Adds a new stream to track.
     * @param {AddStreamRequest} fields Track id to add a stream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTrackStream(
      fields: AddStreamRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).addTrackStream(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComment(
      fields: BlockCommentRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockCommentResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockComment(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks all comments related to user or post.
     * @param {BlockCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComments(
      fields: BlockCommentsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockCommentsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockComments(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks all notifications related to user or entity.
     * @param {BlockNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockNotifications(
      fields: BlockNotificationsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<BlockNotificationsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockNotifications(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPost(
      fields: BlockPostRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockPostResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockPost(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Block user posts and all related comments.
     * @param {BlockPostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPosts(
      fields: BlockPostsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockPostsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockPosts(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks all reports related to user.
     * @param {BlockReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockReports(
      fields: BlockReportsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockReportsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockReports(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Block user's tips in database.
     * @param {BlockTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTips(
      fields: BlockTipsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockTipsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockTips(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTrack(
      fields: BlockTrackRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<EndpointsTracksBlockTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockTrack(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Block user's tracks in database.
     * @param {BlockTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTracks(
      fields: BlockTracksRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<EndpointsTracksBlockTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockTracks(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockUser(
      fields: BlockUserRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BlockUserResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).blockUser(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Boosts track.
     * @param {BoostTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boostTrack(
      fields: BoostTrackRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BoostTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).boostTrack(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Used to cancel subscription to artist.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription(
      fields: CancelSubscriptionRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CancelSubscriptionResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).cancelSubscription(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Cancels stripe subscriptions based on provided user id.
     * @param {CancelSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscriptions(
      fields: CancelSubscriptionsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CancelSubscriptionsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).cancelSubscriptions(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountRefresh(
      accountID: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).connectedAccountRefresh(accountID, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountReturn(
      accountID: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).connectedAccountReturn(accountID, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates subscription to artist.
     * @param {CreateArtistSubscriptionRequest} fields Artist ID to subscribe.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createArtistSubscription(
      fields: CreateArtistSubscriptionRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createArtistSubscription(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a comment.
     * @param {CreateCommentRequest} fields Information for creating comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComment(
      fields: CreateCommentRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateCommentResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createComment(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates connected account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnectedAccount(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreateConnectedAccountResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).createConnectedAccount(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateFileResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).createFile(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a notification.
     * @param {CreateNotificationRequestBody} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNotification(
      fields: CreateNotificationRequestBody,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreateNotificationResponseBody> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createNotification(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates Stripe Payment account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentAccount(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreatePaymentAccountResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).createPaymentAccount(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates Stripe Payment payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentPayout(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreatePaymentPayoutResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).createPaymentPayout(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates payout from stripe to artists bank account.
     * @param {CreatePayoutRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPayout(
      fields: CreatePayoutRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreatePayoutResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createPayout(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a post.
     * @param {CreatePostRequest} fields Post information to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPost(
      fields: CreatePostRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreatePostResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createPost(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a report.
     * @param {CreateReportRequest} fields Information for creating report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createReport(
      fields: CreateReportRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateReportResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createReport(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates setup payment checkout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSetupPaymentCheckout(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<MainCreateSetupPaymentCheckoutHandlerResponseBody> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).createSetupPaymentCheckout(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates subscription to an artist.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubscription(
      fields: CreateSubscriptionRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreateSubscriptionResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createSubscription(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTip(
      fields: CreateTipRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateTipResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createTip(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates track object and stores it in database.
     * @param {CreateTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTrack(
      fields: CreateTrackRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createTrack(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates transfer from platform to artist connected account.
     * @param {CreateTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransfer(
      fields: CreateTransferRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CreateTransferResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).createTransfer(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComment(
      commentId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteCommentResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteComment(commentId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Permanently deletes user's comments and all sub-comments from the platform.
     * @param {DeleteCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComments(
      fields: DeleteCommentsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteCommentsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteComments(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes a file based on provided id, fileId for new files, objectId for old files.
     * @param {DeleteFileRequest} fields options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(
      fields: DeleteFileRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteFileResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteFile(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes user's firebase profile entirely.
     * @param {DeleteFirebaseProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFirebaseProfile(
      fields: DeleteFirebaseProfileRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteFirebaseProfileResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteFirebaseProfile(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete all purchases related to user or single purchase by id.
     * @param {DeleteIOSPurchasesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteIOSPurchases(
      fields: DeleteIOSPurchasesRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteIOSPurchasesResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteIOSPurchases(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLike(
      targetId: string,
      type: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteLike(targetId, type, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes notification by provided id.
     * @param {DeleteNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotification(
      fields: DeleteNotificationRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteNotificationResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteNotification(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationByTermRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotificationByTerm(
      fields: DeleteNotificationByTermRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteNotificationByTermResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteNotificationByTerm(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotifications(
      fields: DeleteNotificationsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteNotificationsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteNotifications(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentMethod(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).deletePaymentMethod(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePost(
      postId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deletePost(postId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Permanently deletes user's posts and all related comments and media data.
     * @param {DeletePostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePosts(
      fields: DeletePostsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeletePostsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deletePosts(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Permanently deletes user's reports from the platform.
     * @param {DeleteReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteReports(
      fields: DeleteReportsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteReportsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteReports(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes stripe connected account by provided id.
     * @param {DeleteStripeConnectedAccountRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeConnectedAccount(
      fields: DeleteStripeConnectedAccountRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteStripeConnectedAccountResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteStripeConnectedAccount(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes stripe customer by provided id.
     * @param {DeleteStripeCustomerRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeCustomer(
      fields: DeleteStripeCustomerRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteStripeCustomerResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteStripeCustomer(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes stripe entities from artist subscription settings based on provided user id.
     * @param {DeleteStripeEntitiesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeEntities(
      fields: DeleteStripeEntitiesRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<DeleteStripeEntitiesResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteStripeEntities(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Permanently deletes user's tips entities from the platform.
     * @param {DeleteTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTips(
      fields: DeleteTipsRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteTipsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteTips(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Removes track from Storage and database.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTrack(
      trackId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteTrack(trackId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Permanently deletes user's tracks from the platform.
     * @param {DeleteTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTracks(
      fields: DeleteTracksRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteTracks(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Deletes user and all user's data from the platform.
     * @param {DeleteUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      fields: DeleteUserRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteUserResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).deleteUser(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Exchanges disposable auth code for Ryddm API auth token.
     * @param {ExchangeDisposableAuthCodeRequest} fields Disposable auth code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeDisposableAuthCode(
      fields: ExchangeDisposableAuthCodeRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<ExchangeDisposableAuthCodeResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).exchangeDisposableAuthCode(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Verify and exchange firebase id token with auth token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeToken(
      fields: ExchangeTokenRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ExchangeTokenResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).exchangeToken(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Generates connected account link.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateConnectedAccountLink(
      userId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GenerateConnectedAccountLinkResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).generateConnectedAccountLink(userId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Retrieves user's available and pending balances.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBalance(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetBalanceResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getBalance(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoostedTracks(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetBoostedTracksResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getBoostedTracks(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {boolean} [exclusiveOnly]
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {Array<string>} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChartTracks(
      exclusiveOnly?: boolean,
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      tags?: Array<string>,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetChartTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getChartTracks(exclusiveOnly, extend, limit, offset, tags, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComment(
      commentId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetCommentResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getComment(commentId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} targetId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComments(
      targetId: string,
      limit?: number,
      offset?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetCommentsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getComments(targetId, limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns stripe connected account ready flag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnectedAccountReady(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetConnectedAccountReadyResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getConnectedAccountReady(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Sends email with confirmation link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeleteUserConfirmationLink(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetDeleteUserConfirmationLinkResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).getDeleteUserConfirmationLink(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Generates disposable auth link.
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDisposableAuthLink(
      redirectUrl?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetDisposableAuthLinkResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getDisposableAuthLink(redirectUrl, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a file.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFile(
      fileId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getFile(fileId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of followed by the user users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFollowedUserIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetFollowedUserIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getFollowedUserIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Checks if post is already unlocked.
     * @param {string} postId
     * @param {string} sourceUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsPostUnlocked(
      postId: string,
      sourceUserId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetIsPostUnlockedResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getIsPostUnlocked(postId, sourceUserId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Checks if track is boosted and boost duration still going.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackBoosted(
      trackId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetIsTrackBoostedResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getIsTrackBoosted(trackId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Checks if track is already unlocked.
     * @param {string} sourceUserId
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackUnlocked(
      sourceUserId: string,
      trackId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetIsTrackUnlockedResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getIsTrackUnlocked(sourceUserId, trackId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns artists followed by user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetLikedArtistsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getLikedArtists(userId, limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedCommentIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetLikedCommentIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getLikedCommentIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPostIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetLikedPostIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getLikedPostIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of posts liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetLikedPostsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getLikedPosts(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of liked by the user track ids .
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTrackIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetLikedTrackIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getLikedTrackIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of tracks liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetLikedTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getLikedTracks(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of notifications.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(
      limit?: number,
      offset?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetNotificationsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getNotifications(limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentMethod(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<EndpointsPaymentsGetPaymentMethodRequest> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getPaymentMethod(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get list of recent payments from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetPaymentTransactionsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getPaymentTransactions(endingBefore, limit, startingAfter, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get list of recent payouts from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayoutTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetPayoutTransactionsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getPayoutTransactions(endingBefore, limit, startingAfter, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a post by id.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPost(
      postId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetPostResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getPost(postId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Creates a post.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'personal' | 'popular' | 'username'} [type]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosts(
      limit?: number,
      offset?: number,
      type?: "personal" | "popular" | "username",
      userUsername?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetPostsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getPosts(limit, offset, type, userUsername, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns the list of tracks for artist profile.
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfileTracks(
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      userUsername?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetProfileTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getProfileTracks(extend, limit, offset, userUsername, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns artist's referral code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReferralCode(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetReferralCodeResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getReferralCode(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns status of report by provided id.
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport(
      reportId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetReportResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getReport(reportId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns messages related to certain report.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportMessages(
      reportId: string,
      limit?: number,
      offset?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetReportMessagesResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getReportMessages(reportId, limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of reports.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReports(
      limit?: number,
      offset?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetReportsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getReports(limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns artist referral stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStats(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetStatsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getStats(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns artists the user is subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSubscribedToArtistsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getSubscribedToArtists(userId, limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of user ids source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSubscribedToIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getSubscribedToIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns subscription settings.
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(
      userId?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSubscriptionResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getSubscription(userId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns subscription stats.
     * @param {number} lastSubscribersCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStats(
      lastSubscribersCount: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSubscriptionStatsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getSubscriptionStats(lastSubscribersCount, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns subscription status.
     * @param {string} artistId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStatus(
      artistId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSubscriptionStatusResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getSubscriptionStatus(artistId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Finds and returns suggested artist profiles.
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuggestedArtists(
      limit?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetSuggestedArtistsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getSuggestedArtists(limit, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a tip by id.
     * @param {string} tipId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTip(
      tipId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTipResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getTip(tipId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Find and return users income tip entries.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTips(
      limit?: number,
      offset?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTipsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getTips(limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns track by provided id.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrack(
      trackId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getTrack(trackId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {string} [userId]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTracks(
      limit?: number,
      offset?: number,
      search?: string,
      userId?: string,
      userUsername?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getTracks(limit, offset, search, userId, userUsername, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of posts unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUnlockedPostsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUnlockedPosts(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of unlocked by the user posts ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPostsIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUnlockedPostsIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getUnlockedPostsIDs(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of tracks unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUnlockedTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUnlockedTracks(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns a list of unlocked by the user tracks ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracksIDs(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUnlockedTracksIDsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getUnlockedTracksIDs(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns count of unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnreadNotificationsCount(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUnreadNotificationsCountResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getUnreadNotificationsCount(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Finds and returns user by user id.
     * @param {Array<string>} [extend]
     * @param {string} [userId] UserID       string           &#x60;form:\&quot;userId\&quot;       json:\&quot;userId\&quot;       url:\&quot;userId\&quot; binding:\&quot;-\&quot;&#x60; UserUsername string           &#x60;form:\&quot;userUsername\&quot; json:\&quot;userUsername\&quot; url:\&quot;userUsername\&quot; binding:\&quot;-\&quot;&#x60;
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      extend?: Array<string>,
      userId?: string,
      userUsername?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetUserResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUser(extend, userId, userUsername, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Return a list of user comments (admins only).
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserComments(
      userId: string,
      limit?: number,
      offset?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUserCommentsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUserComments(userId, limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Gets user deletion instruction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDeletionInstructions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).getUserDeletionInstructions(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns user suggestions by username.
     * @param {string} searchUsername
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSuggestions(
      searchUsername: string,
      limit?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUserSuggestionsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUserSuggestions(searchUsername, limit, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Checks if given username is available for registration.
     * @param {string} username Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsernameAvailable(
      username: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetUsernameAvailableResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).getUsernameAvailable(username, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles IOS IAP server-to-server notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSIAPWebhook(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IOSIAPWebhookHandlerResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).iOSIAPWebhook(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Unlocks post in ios.
     * @param {IOSPostUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSPostUnlock(
      fields: IOSPostUnlockRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<IOSPostUnlockResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).iOSPostUnlock(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Boosts track in ios.
     * @param {IOSTrackBoostRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackBoost(
      fields: IOSTrackBoostRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<IOSTrackBoostResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).iOSTrackBoost(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Unlocks track in ios.
     * @param {IOSTrackUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackUnlock(
      fields: IOSTrackUnlockRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IOSTrackUnlockResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).iOSTrackUnlock(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Finds and returns all user's liked track IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    likesGET(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetUserResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).likesGET(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {LoginRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(
      fields: LoginRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<LoginResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).login(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Pauses stripe subscriptions based on provided user id.
     * @param {PauseSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pauseSubscriptions(
      fields: PauseSubscriptionsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<PauseSubscriptionsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).pauseSubscriptions(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountrefreshGET(
      accountID: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).paymentsaccountrefreshGET(accountID, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountreturnGET(
      accountID: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).paymentsaccountreturnGET(accountID, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `checkout.session.completed` stripe event and deletes all old user cards.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhookscheckoutSessionCompletedPOST(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).paymentswebhookscheckoutSessionCompletedPOST(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhooksinvoicePaymentFailedPOST(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).paymentswebhooksinvoicePaymentFailedPOST(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Pings microservice.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).ping(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Reads notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readNotifications(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<ReadNotificationsResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).readNotifications(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Verify and prolong users auth token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<RefreshTokenResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).refreshToken(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(
      fields: RegisterRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<RegisterResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).register(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterFanRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerFan(
      fields: RegisterFanRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<RegisterFanResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).registerFan(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Resolves the reports related to passed report id.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveReport(
      fields: ResolveReportRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ResolveReportResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).resolveReport(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Reverse previously created transfer from platform to artist connected account.
     * @param {ReverseTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reverseTransfer(
      fields: ReverseTransferRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<ReverseTransferResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).reverseTransfer(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchArtists(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<SearchArtistsResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).searchArtists(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<SearchTracksResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).searchTracks(limit, offset, search, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `customer.subscription.deleted` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionswebhookssubscriptionDeletedPOST(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).subscriptionswebhookssubscriptionDeletedPOST(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Unlocks post.
     * @param {UnlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockPost(
      fields: UnlockPostRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UnlockPostResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).unlockPost(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Unlocks track.
     * @param {UnlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockTrack(
      fields: UnlockTrackRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UnlockTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).unlockTrack(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Updates user activity time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateActivityTime(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<UpdateActivityResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).updateActivityTime(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Updates subscription.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).updateSubscription(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Updates subscription price.
     * @param {UpdateSubscriptionPriceRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscriptionPrice(
      fields: UpdateSubscriptionPriceRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<UpdateSubscriptionPriceResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).updateSubscriptionPrice(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Updates track by track id.
     * @param {UpdateTrackRequest} fields Track information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTrack(
      fields: UpdateTrackRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).updateTrack(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Updates the current user.
     * @param {UpdateUserRequest} fields User information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      fields: UpdateUserRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateUserResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).updateUser(fields, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Uploads the track to Google Cloud Storage.
     * @param {any} track Track to upload.
     * @param {any} cover Track cover to upload.
     * @param {string} name Track name (title).
     * @param {Array<string>} tags Track tags.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrack(
      track: any,
      cover: any,
      name: string,
      tags: Array<string>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UploadTrackResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).uploadTrack(track, cover, name, tags, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Uploads the track cover to Google Cloud Storage.
     * @param {any} cover Cover to upload.
     * @param {string} trackID Track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrackCover(
      cover: any,
      trackID: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<UploadTrackCoverResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).uploadTrackCover(cover, trackID, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Uploads user avatar to Google Cloud Storage.
     * @param {any} avatar User avatar to upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadUserAvatar(
      avatar: any,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<UploadUserAvatarResponse> {
      const localVarFetchArgs = DefaultApiFetchParamCreator(
        configuration
      ).uploadUserAvatar(avatar, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Returns monetization info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webGetMonetizationStatus(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WebGetMonetizationStatusResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).webGetMonetizationStatus(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event and sets subscription status to 'payment_failed'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentFailed(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WebhookInvoicePaymentFailedResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).webhookInvoicePaymentFailed(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `invoice.payment_succeeded` stripe event and sets subscription status to 'active'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentSucceeded(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WebhookInvoicePaymentSucceededResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).webhookInvoicePaymentSucceeded(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `setup_intent.succeeded` stripe event and creates subscription in stripe and database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookSetupIntentSucceeded(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WebhookSetupIntentSucceededResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(configuration).webhookSetupIntentSucceeded(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Handles `payment_intent.succeeded` stripe event and sets tip status to 'paid'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookTipPaymentIntentSucceeded(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WebhookTipPaymentIntentSucceededResponse> {
      const localVarFetchArgs =
        DefaultApiFetchParamCreator(
          configuration
        ).webhookTipPaymentIntentSucceeded(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Adds like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLike(targetId: string, type: string, options?: any) {
      return DefaultApiFp(configuration).addLike(
        targetId,
        type,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Adds a new stream to track.
     * @param {AddStreamRequest} fields Track id to add a stream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTrackStream(fields: AddStreamRequest, options?: any) {
      return DefaultApiFp(configuration).addTrackStream(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComment(fields: BlockCommentRequest, options?: any) {
      return DefaultApiFp(configuration).blockComment(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks all comments related to user or post.
     * @param {BlockCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockComments(fields: BlockCommentsRequest, options?: any) {
      return DefaultApiFp(configuration).blockComments(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks all notifications related to user or entity.
     * @param {BlockNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockNotifications(fields: BlockNotificationsRequest, options?: any) {
      return DefaultApiFp(configuration).blockNotifications(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPost(fields: BlockPostRequest, options?: any) {
      return DefaultApiFp(configuration).blockPost(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Block user posts and all related comments.
     * @param {BlockPostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockPosts(fields: BlockPostsRequest, options?: any) {
      return DefaultApiFp(configuration).blockPosts(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks all reports related to user.
     * @param {BlockReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockReports(fields: BlockReportsRequest, options?: any) {
      return DefaultApiFp(configuration).blockReports(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Block user's tips in database.
     * @param {BlockTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTips(fields: BlockTipsRequest, options?: any) {
      return DefaultApiFp(configuration).blockTips(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTrack(fields: BlockTrackRequest, options?: any) {
      return DefaultApiFp(configuration).blockTrack(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Block user's tracks in database.
     * @param {BlockTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockTracks(fields: BlockTracksRequest, options?: any) {
      return DefaultApiFp(configuration).blockTracks(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockUser(fields: BlockUserRequest, options?: any) {
      return DefaultApiFp(configuration).blockUser(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Boosts track.
     * @param {BoostTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boostTrack(fields: BoostTrackRequest, options?: any) {
      return DefaultApiFp(configuration).boostTrack(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Used to cancel subscription to artist.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription(fields: CancelSubscriptionRequest, options?: any) {
      return DefaultApiFp(configuration).cancelSubscription(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Cancels stripe subscriptions based on provided user id.
     * @param {CancelSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscriptions(fields: CancelSubscriptionsRequest, options?: any) {
      return DefaultApiFp(configuration).cancelSubscriptions(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountRefresh(accountID: string, options?: any) {
      return DefaultApiFp(configuration).connectedAccountRefresh(
        accountID,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectedAccountReturn(accountID: string, options?: any) {
      return DefaultApiFp(configuration).connectedAccountReturn(
        accountID,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Creates subscription to artist.
     * @param {CreateArtistSubscriptionRequest} fields Artist ID to subscribe.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createArtistSubscription(
      fields: CreateArtistSubscriptionRequest,
      options?: any
    ) {
      return DefaultApiFp(configuration).createArtistSubscription(
        fields,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Creates a comment.
     * @param {CreateCommentRequest} fields Information for creating comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComment(fields: CreateCommentRequest, options?: any) {
      return DefaultApiFp(configuration).createComment(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates connected account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnectedAccount(options?: any) {
      return DefaultApiFp(configuration).createConnectedAccount(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates a file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile(options?: any) {
      return DefaultApiFp(configuration).createFile(options)(fetch, basePath);
    },
    /**
     *
     * @summary Creates a notification.
     * @param {CreateNotificationRequestBody} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNotification(fields: CreateNotificationRequestBody, options?: any) {
      return DefaultApiFp(configuration).createNotification(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates Stripe Payment account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentAccount(options?: any) {
      return DefaultApiFp(configuration).createPaymentAccount(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates Stripe Payment payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPaymentPayout(options?: any) {
      return DefaultApiFp(configuration).createPaymentPayout(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates payout from stripe to artists bank account.
     * @param {CreatePayoutRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPayout(fields: CreatePayoutRequest, options?: any) {
      return DefaultApiFp(configuration).createPayout(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates a post.
     * @param {CreatePostRequest} fields Post information to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPost(fields: CreatePostRequest, options?: any) {
      return DefaultApiFp(configuration).createPost(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates a report.
     * @param {CreateReportRequest} fields Information for creating report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createReport(fields: CreateReportRequest, options?: any) {
      return DefaultApiFp(configuration).createReport(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates setup payment checkout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSetupPaymentCheckout(options?: any) {
      return DefaultApiFp(configuration).createSetupPaymentCheckout(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates subscription to an artist.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubscription(fields: CreateSubscriptionRequest, options?: any) {
      return DefaultApiFp(configuration).createSubscription(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates a tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTip(fields: CreateTipRequest, options?: any) {
      return DefaultApiFp(configuration).createTip(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates track object and stores it in database.
     * @param {CreateTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTrack(fields: CreateTrackRequest, options?: any) {
      return DefaultApiFp(configuration).createTrack(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates transfer from platform to artist connected account.
     * @param {CreateTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransfer(fields: CreateTransferRequest, options?: any) {
      return DefaultApiFp(configuration).createTransfer(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComment(commentId: string, options?: any) {
      return DefaultApiFp(configuration).deleteComment(commentId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Permanently deletes user's comments and all sub-comments from the platform.
     * @param {DeleteCommentsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteComments(fields: DeleteCommentsRequest, options?: any) {
      return DefaultApiFp(configuration).deleteComments(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes a file based on provided id, fileId for new files, objectId for old files.
     * @param {DeleteFileRequest} fields options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(fields: DeleteFileRequest, options?: any) {
      return DefaultApiFp(configuration).deleteFile(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes user's firebase profile entirely.
     * @param {DeleteFirebaseProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFirebaseProfile(fields: DeleteFirebaseProfileRequest, options?: any) {
      return DefaultApiFp(configuration).deleteFirebaseProfile(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Delete all purchases related to user or single purchase by id.
     * @param {DeleteIOSPurchasesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteIOSPurchases(fields: DeleteIOSPurchasesRequest, options?: any) {
      return DefaultApiFp(configuration).deleteIOSPurchases(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes like.
     * @param {string} targetId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLike(targetId: string, type: string, options?: any) {
      return DefaultApiFp(configuration).deleteLike(
        targetId,
        type,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Deletes notification by provided id.
     * @param {DeleteNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotification(fields: DeleteNotificationRequest, options?: any) {
      return DefaultApiFp(configuration).deleteNotification(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationByTermRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotificationByTerm(
      fields: DeleteNotificationByTermRequest,
      options?: any
    ) {
      return DefaultApiFp(configuration).deleteNotificationByTerm(
        fields,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Delete all notifications related to user or entity.
     * @param {DeleteNotificationsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteNotifications(fields: DeleteNotificationsRequest, options?: any) {
      return DefaultApiFp(configuration).deleteNotifications(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Delete user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentMethod(options?: any) {
      return DefaultApiFp(configuration).deletePaymentMethod(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePost(postId: string, options?: any) {
      return DefaultApiFp(configuration).deletePost(postId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Permanently deletes user's posts and all related comments and media data.
     * @param {DeletePostsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePosts(fields: DeletePostsRequest, options?: any) {
      return DefaultApiFp(configuration).deletePosts(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Permanently deletes user's reports from the platform.
     * @param {DeleteReportsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteReports(fields: DeleteReportsRequest, options?: any) {
      return DefaultApiFp(configuration).deleteReports(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes stripe connected account by provided id.
     * @param {DeleteStripeConnectedAccountRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeConnectedAccount(
      fields: DeleteStripeConnectedAccountRequest,
      options?: any
    ) {
      return DefaultApiFp(configuration).deleteStripeConnectedAccount(
        fields,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Deletes stripe customer by provided id.
     * @param {DeleteStripeCustomerRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeCustomer(fields: DeleteStripeCustomerRequest, options?: any) {
      return DefaultApiFp(configuration).deleteStripeCustomer(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes stripe entities from artist subscription settings based on provided user id.
     * @param {DeleteStripeEntitiesRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStripeEntities(fields: DeleteStripeEntitiesRequest, options?: any) {
      return DefaultApiFp(configuration).deleteStripeEntities(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Permanently deletes user's tips entities from the platform.
     * @param {DeleteTipsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTips(fields: DeleteTipsRequest, options?: any) {
      return DefaultApiFp(configuration).deleteTips(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Removes track from Storage and database.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTrack(trackId: string, options?: any) {
      return DefaultApiFp(configuration).deleteTrack(trackId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Permanently deletes user's tracks from the platform.
     * @param {DeleteTracksRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTracks(fields: DeleteTracksRequest, options?: any) {
      return DefaultApiFp(configuration).deleteTracks(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Deletes user and all user's data from the platform.
     * @param {DeleteUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(fields: DeleteUserRequest, options?: any) {
      return DefaultApiFp(configuration).deleteUser(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Exchanges disposable auth code for Ryddm API auth token.
     * @param {ExchangeDisposableAuthCodeRequest} fields Disposable auth code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeDisposableAuthCode(
      fields: ExchangeDisposableAuthCodeRequest,
      options?: any
    ) {
      return DefaultApiFp(configuration).exchangeDisposableAuthCode(
        fields,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Verify and exchange firebase id token with auth token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeToken(fields: ExchangeTokenRequest, options?: any) {
      return DefaultApiFp(configuration).exchangeToken(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Generates connected account link.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateConnectedAccountLink(userId: string, options?: any) {
      return DefaultApiFp(configuration).generateConnectedAccountLink(
        userId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Retrieves user's available and pending balances.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBalance(options?: any) {
      return DefaultApiFp(configuration).getBalance(options)(fetch, basePath);
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoostedTracks(options?: any) {
      return DefaultApiFp(configuration).getBoostedTracks(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {boolean} [exclusiveOnly]
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {Array<string>} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChartTracks(
      exclusiveOnly?: boolean,
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      tags?: Array<string>,
      options?: any
    ) {
      return DefaultApiFp(configuration).getChartTracks(
        exclusiveOnly,
        extend,
        limit,
        offset,
        tags,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComment(commentId: string, options?: any) {
      return DefaultApiFp(configuration).getComment(commentId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of comments.
     * @param {string} targetId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComments(
      targetId: string,
      limit?: number,
      offset?: number,
      options?: any
    ) {
      return DefaultApiFp(configuration).getComments(
        targetId,
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns stripe connected account ready flag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnectedAccountReady(options?: any) {
      return DefaultApiFp(configuration).getConnectedAccountReady(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Sends email with confirmation link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeleteUserConfirmationLink(options?: any) {
      return DefaultApiFp(configuration).getDeleteUserConfirmationLink(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Generates disposable auth link.
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDisposableAuthLink(redirectUrl?: string, options?: any) {
      return DefaultApiFp(configuration).getDisposableAuthLink(
        redirectUrl,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Creates a file.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFile(fileId: string, options?: any) {
      return DefaultApiFp(configuration).getFile(fileId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of followed by the user users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFollowedUserIDs(options?: any) {
      return DefaultApiFp(configuration).getFollowedUserIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Checks if post is already unlocked.
     * @param {string} postId
     * @param {string} sourceUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsPostUnlocked(postId: string, sourceUserId: string, options?: any) {
      return DefaultApiFp(configuration).getIsPostUnlocked(
        postId,
        sourceUserId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Checks if track is boosted and boost duration still going.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackBoosted(trackId: string, options?: any) {
      return DefaultApiFp(configuration).getIsTrackBoosted(trackId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Checks if track is already unlocked.
     * @param {string} sourceUserId
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIsTrackUnlocked(sourceUserId: string, trackId: string, options?: any) {
      return DefaultApiFp(configuration).getIsTrackUnlocked(
        sourceUserId,
        trackId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns artists followed by user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getLikedArtists(
        userId,
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of liked by the user comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedCommentIDs(options?: any) {
      return DefaultApiFp(configuration).getLikedCommentIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of liked by the user post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPostIDs(options?: any) {
      return DefaultApiFp(configuration).getLikedPostIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of posts liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getLikedPosts(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of liked by the user track ids .
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTrackIDs(options?: any) {
      return DefaultApiFp(configuration).getLikedTrackIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of tracks liked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLikedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getLikedTracks(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of notifications.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(limit?: number, offset?: number, options?: any) {
      return DefaultApiFp(configuration).getNotifications(
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get user's payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentMethod(options?: any) {
      return DefaultApiFp(configuration).getPaymentMethod(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Get list of recent payments from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getPaymentTransactions(
        endingBefore,
        limit,
        startingAfter,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get list of recent payouts from stripe connected account.
     * @param {string} [endingBefore]
     * @param {number} [limit]
     * @param {string} [startingAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayoutTransactions(
      endingBefore?: string,
      limit?: number,
      startingAfter?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getPayoutTransactions(
        endingBefore,
        limit,
        startingAfter,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a post by id.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPost(postId: string, options?: any) {
      return DefaultApiFp(configuration).getPost(postId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Creates a post.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'personal' | 'popular' | 'username'} [type]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosts(
      limit?: number,
      offset?: number,
      type?: "personal" | "popular" | "username",
      userUsername?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getPosts(
        limit,
        offset,
        type,
        userUsername,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns the list of tracks for artist profile.
     * @param {Array<string>} [extend]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfileTracks(
      extend?: Array<string>,
      limit?: number,
      offset?: number,
      userUsername?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getProfileTracks(
        extend,
        limit,
        offset,
        userUsername,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns artist's referral code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReferralCode(options?: any) {
      return DefaultApiFp(configuration).getReferralCode(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns status of report by provided id.
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport(reportId: string, options?: any) {
      return DefaultApiFp(configuration).getReport(reportId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns messages related to certain report.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportMessages(
      reportId: string,
      limit?: number,
      offset?: number,
      options?: any
    ) {
      return DefaultApiFp(configuration).getReportMessages(
        reportId,
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of reports.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReports(limit?: number, offset?: number, options?: any) {
      return DefaultApiFp(configuration).getReports(
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns artist referral stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStats(options?: any) {
      return DefaultApiFp(configuration).getStats(options)(fetch, basePath);
    },
    /**
     *
     * @summary Returns artists the user is subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToArtists(
      userId: string,
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getSubscribedToArtists(
        userId,
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of user ids source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscribedToIDs(options?: any) {
      return DefaultApiFp(configuration).getSubscribedToIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns subscription settings.
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(userId?: string, options?: any) {
      return DefaultApiFp(configuration).getSubscription(userId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns subscription stats.
     * @param {number} lastSubscribersCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStats(lastSubscribersCount: number, options?: any) {
      return DefaultApiFp(configuration).getSubscriptionStats(
        lastSubscribersCount,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns subscription status.
     * @param {string} artistId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionStatus(artistId: string, options?: any) {
      return DefaultApiFp(configuration).getSubscriptionStatus(
        artistId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Finds and returns suggested artist profiles.
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuggestedArtists(limit?: number, options?: any) {
      return DefaultApiFp(configuration).getSuggestedArtists(limit, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a tip by id.
     * @param {string} tipId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTip(tipId: string, options?: any) {
      return DefaultApiFp(configuration).getTip(tipId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Find and return users income tip entries.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTips(limit?: number, offset?: number, options?: any) {
      return DefaultApiFp(configuration).getTips(
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns track by provided id.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrack(trackId: string, options?: any) {
      return DefaultApiFp(configuration).getTrack(trackId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns the list of tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {string} [userId]
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTracks(
      limit?: number,
      offset?: number,
      search?: string,
      userId?: string,
      userUsername?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getTracks(
        limit,
        offset,
        search,
        userId,
        userUsername,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of posts unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPosts(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getUnlockedPosts(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of unlocked by the user posts ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedPostsIDs(options?: any) {
      return DefaultApiFp(configuration).getUnlockedPostsIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns a list of tracks unlocked by the user.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getUnlockedTracks(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Returns a list of unlocked by the user tracks ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnlockedTracksIDs(options?: any) {
      return DefaultApiFp(configuration).getUnlockedTracksIDs(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns count of unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnreadNotificationsCount(options?: any) {
      return DefaultApiFp(configuration).getUnreadNotificationsCount(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Finds and returns user by user id.
     * @param {Array<string>} [extend]
     * @param {string} [userId] UserID       string           &#x60;form:\&quot;userId\&quot;       json:\&quot;userId\&quot;       url:\&quot;userId\&quot; binding:\&quot;-\&quot;&#x60; UserUsername string           &#x60;form:\&quot;userUsername\&quot; json:\&quot;userUsername\&quot; url:\&quot;userUsername\&quot; binding:\&quot;-\&quot;&#x60;
     * @param {string} [userUsername]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      extend?: Array<string>,
      userId?: string,
      userUsername?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).getUser(
        extend,
        userId,
        userUsername,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Return a list of user comments (admins only).
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserComments(
      userId: string,
      limit?: number,
      offset?: number,
      options?: any
    ) {
      return DefaultApiFp(configuration).getUserComments(
        userId,
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Gets user deletion instruction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDeletionInstructions(options?: any) {
      return DefaultApiFp(configuration).getUserDeletionInstructions(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns user suggestions by username.
     * @param {string} searchUsername
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSuggestions(searchUsername: string, limit?: number, options?: any) {
      return DefaultApiFp(configuration).getUserSuggestions(
        searchUsername,
        limit,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Checks if given username is available for registration.
     * @param {string} username Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsernameAvailable(username: string, options?: any) {
      return DefaultApiFp(configuration).getUsernameAvailable(
        username,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Handles IOS IAP server-to-server notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSIAPWebhook(options?: any) {
      return DefaultApiFp(configuration).iOSIAPWebhook(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Unlocks post in ios.
     * @param {IOSPostUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSPostUnlock(fields: IOSPostUnlockRequest, options?: any) {
      return DefaultApiFp(configuration).iOSPostUnlock(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Boosts track in ios.
     * @param {IOSTrackBoostRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackBoost(fields: IOSTrackBoostRequest, options?: any) {
      return DefaultApiFp(configuration).iOSTrackBoost(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Unlocks track in ios.
     * @param {IOSTrackUnlockRequest} fields Purchase info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iOSTrackUnlock(fields: IOSTrackUnlockRequest, options?: any) {
      return DefaultApiFp(configuration).iOSTrackUnlock(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Finds and returns all user's liked track IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    likesGET(options?: any) {
      return DefaultApiFp(configuration).likesGET(options)(fetch, basePath);
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {LoginRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(fields: LoginRequest, options?: any) {
      return DefaultApiFp(configuration).login(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Pauses stripe subscriptions based on provided user id.
     * @param {PauseSubscriptionsRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pauseSubscriptions(fields: PauseSubscriptionsRequest, options?: any) {
      return DefaultApiFp(configuration).pauseSubscriptions(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Recreates an account link for Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountrefreshGET(accountID: string, options?: any) {
      return DefaultApiFp(configuration).paymentsaccountrefreshGET(
        accountID,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Completes creating Stripe connected account.
     * @param {string} accountID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsaccountreturnGET(accountID: string, options?: any) {
      return DefaultApiFp(configuration).paymentsaccountreturnGET(
        accountID,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Handles `checkout.session.completed` stripe event and deletes all old user cards.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhookscheckoutSessionCompletedPOST(options?: any) {
      return DefaultApiFp(
        configuration
      ).paymentswebhookscheckoutSessionCompletedPOST(options)(fetch, basePath);
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentswebhooksinvoicePaymentFailedPOST(options?: any) {
      return DefaultApiFp(
        configuration
      ).paymentswebhooksinvoicePaymentFailedPOST(options)(fetch, basePath);
    },
    /**
     *
     * @summary Pings microservice.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping(options?: any) {
      return DefaultApiFp(configuration).ping(options)(fetch, basePath);
    },
    /**
     *
     * @summary Reads notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readNotifications(options?: any) {
      return DefaultApiFp(configuration).readNotifications(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Verify and prolong users auth token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options?: any) {
      return DefaultApiFp(configuration).refreshToken(options)(fetch, basePath);
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(fields: RegisterRequest, options?: any) {
      return DefaultApiFp(configuration).register(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Exchanges Firebase ID token for Ryddm API auth token.
     * @param {RegisterFanRequest} fields Firebase token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerFan(fields: RegisterFanRequest, options?: any) {
      return DefaultApiFp(configuration).registerFan(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Resolves the reports related to passed report id.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveReport(fields: ResolveReportRequest, options?: any) {
      return DefaultApiFp(configuration).resolveReport(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Reverse previously created transfer from platform to artist connected account.
     * @param {ReverseTransferRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reverseTransfer(fields: ReverseTransferRequest, options?: any) {
      return DefaultApiFp(configuration).reverseTransfer(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchArtists(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).searchArtists(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Searches track in database.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchTracks(
      limit?: number,
      offset?: number,
      search?: string,
      options?: any
    ) {
      return DefaultApiFp(configuration).searchTracks(
        limit,
        offset,
        search,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Handles `customer.subscription.deleted` stripe event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionswebhookssubscriptionDeletedPOST(options?: any) {
      return DefaultApiFp(
        configuration
      ).subscriptionswebhookssubscriptionDeletedPOST(options)(fetch, basePath);
    },
    /**
     *
     * @summary Unlocks post.
     * @param {UnlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockPost(fields: UnlockPostRequest, options?: any) {
      return DefaultApiFp(configuration).unlockPost(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Unlocks track.
     * @param {UnlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockTrack(fields: UnlockTrackRequest, options?: any) {
      return DefaultApiFp(configuration).unlockTrack(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Updates user activity time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateActivityTime(options?: any) {
      return DefaultApiFp(configuration).updateActivityTime(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Updates subscription.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription(options?: any) {
      return DefaultApiFp(configuration).updateSubscription(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Updates subscription price.
     * @param {UpdateSubscriptionPriceRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscriptionPrice(
      fields: UpdateSubscriptionPriceRequest,
      options?: any
    ) {
      return DefaultApiFp(configuration).updateSubscriptionPrice(
        fields,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Updates track by track id.
     * @param {UpdateTrackRequest} fields Track information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTrack(fields: UpdateTrackRequest, options?: any) {
      return DefaultApiFp(configuration).updateTrack(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Updates the current user.
     * @param {UpdateUserRequest} fields User information to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(fields: UpdateUserRequest, options?: any) {
      return DefaultApiFp(configuration).updateUser(fields, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Uploads the track to Google Cloud Storage.
     * @param {any} track Track to upload.
     * @param {any} cover Track cover to upload.
     * @param {string} name Track name (title).
     * @param {Array<string>} tags Track tags.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrack(
      track: any,
      cover: any,
      name: string,
      tags: Array<string>,
      options?: any
    ) {
      return DefaultApiFp(configuration).uploadTrack(
        track,
        cover,
        name,
        tags,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Uploads the track cover to Google Cloud Storage.
     * @param {any} cover Cover to upload.
     * @param {string} trackID Track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTrackCover(cover: any, trackID: string, options?: any) {
      return DefaultApiFp(configuration).uploadTrackCover(
        cover,
        trackID,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Uploads user avatar to Google Cloud Storage.
     * @param {any} avatar User avatar to upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadUserAvatar(avatar: any, options?: any) {
      return DefaultApiFp(configuration).uploadUserAvatar(avatar, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Returns monetization info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webGetMonetizationStatus(options?: any) {
      return DefaultApiFp(configuration).webGetMonetizationStatus(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Handles `invoice.payment_failed` stripe event and sets subscription status to 'payment_failed'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentFailed(options?: any) {
      return DefaultApiFp(configuration).webhookInvoicePaymentFailed(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Handles `invoice.payment_succeeded` stripe event and sets subscription status to 'active'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookInvoicePaymentSucceeded(options?: any) {
      return DefaultApiFp(configuration).webhookInvoicePaymentSucceeded(
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Handles `setup_intent.succeeded` stripe event and creates subscription in stripe and database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookSetupIntentSucceeded(options?: any) {
      return DefaultApiFp(configuration).webhookSetupIntentSucceeded(options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @summary Handles `payment_intent.succeeded` stripe event and sets tip status to 'paid'.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhookTipPaymentIntentSucceeded(options?: any) {
      return DefaultApiFp(configuration).webhookTipPaymentIntentSucceeded(
        options
      )(fetch, basePath);
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Adds like.
   * @param {string} targetId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public addLike(targetId: string, type: string, options?: any) {
    return DefaultApiFp(this.configuration).addLike(
      targetId,
      type,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Adds a new stream to track.
   * @param {AddStreamRequest} fields Track id to add a stream.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public addTrackStream(fields: AddStreamRequest, options?: any) {
    return DefaultApiFp(this.configuration).addTrackStream(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks comment.
   * @param {BlockCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockComment(fields: BlockCommentRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockComment(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks all comments related to user or post.
   * @param {BlockCommentsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockComments(fields: BlockCommentsRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockComments(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks all notifications related to user or entity.
   * @param {BlockNotificationsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockNotifications(fields: BlockNotificationsRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockNotifications(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks post.
   * @param {BlockPostRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockPost(fields: BlockPostRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockPost(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Block user posts and all related comments.
   * @param {BlockPostsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockPosts(fields: BlockPostsRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockPosts(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks all reports related to user.
   * @param {BlockReportsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockReports(fields: BlockReportsRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockReports(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Block user's tips in database.
   * @param {BlockTipsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockTips(fields: BlockTipsRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockTips(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks track.
   * @param {BlockTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockTrack(fields: BlockTrackRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockTrack(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Block user's tracks in database.
   * @param {BlockTracksRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockTracks(fields: BlockTracksRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockTracks(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Blocks user.
   * @param {BlockUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public blockUser(fields: BlockUserRequest, options?: any) {
    return DefaultApiFp(this.configuration).blockUser(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Boosts track.
   * @param {BoostTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public boostTrack(fields: BoostTrackRequest, options?: any) {
    return DefaultApiFp(this.configuration).boostTrack(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Used to cancel subscription to artist.
   * @param {CancelSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public cancelSubscription(fields: CancelSubscriptionRequest, options?: any) {
    return DefaultApiFp(this.configuration).cancelSubscription(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Cancels stripe subscriptions based on provided user id.
   * @param {CancelSubscriptionsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public cancelSubscriptions(
    fields: CancelSubscriptionsRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).cancelSubscriptions(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Recreates an account link for Stripe connected account.
   * @param {string} accountID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public connectedAccountRefresh(accountID: string, options?: any) {
    return DefaultApiFp(this.configuration).connectedAccountRefresh(
      accountID,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Completes creating Stripe connected account.
   * @param {string} accountID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public connectedAccountReturn(accountID: string, options?: any) {
    return DefaultApiFp(this.configuration).connectedAccountReturn(
      accountID,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Creates subscription to artist.
   * @param {CreateArtistSubscriptionRequest} fields Artist ID to subscribe.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createArtistSubscription(
    fields: CreateArtistSubscriptionRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).createArtistSubscription(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Creates a comment.
   * @param {CreateCommentRequest} fields Information for creating comment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createComment(fields: CreateCommentRequest, options?: any) {
    return DefaultApiFp(this.configuration).createComment(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates connected account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createConnectedAccount(options?: any) {
    return DefaultApiFp(this.configuration).createConnectedAccount(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a file.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createFile(options?: any) {
    return DefaultApiFp(this.configuration).createFile(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a notification.
   * @param {CreateNotificationRequestBody} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createNotification(
    fields: CreateNotificationRequestBody,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).createNotification(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates Stripe Payment account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPaymentAccount(options?: any) {
    return DefaultApiFp(this.configuration).createPaymentAccount(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates Stripe Payment payout.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPaymentPayout(options?: any) {
    return DefaultApiFp(this.configuration).createPaymentPayout(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates payout from stripe to artists bank account.
   * @param {CreatePayoutRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPayout(fields: CreatePayoutRequest, options?: any) {
    return DefaultApiFp(this.configuration).createPayout(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a post.
   * @param {CreatePostRequest} fields Post information to create.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPost(fields: CreatePostRequest, options?: any) {
    return DefaultApiFp(this.configuration).createPost(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a report.
   * @param {CreateReportRequest} fields Information for creating report.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createReport(fields: CreateReportRequest, options?: any) {
    return DefaultApiFp(this.configuration).createReport(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates setup payment checkout.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createSetupPaymentCheckout(options?: any) {
    return DefaultApiFp(this.configuration).createSetupPaymentCheckout(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates subscription to an artist.
   * @param {CreateSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createSubscription(fields: CreateSubscriptionRequest, options?: any) {
    return DefaultApiFp(this.configuration).createSubscription(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a tip.
   * @param {CreateTipRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createTip(fields: CreateTipRequest, options?: any) {
    return DefaultApiFp(this.configuration).createTip(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates track object and stores it in database.
   * @param {CreateTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createTrack(fields: CreateTrackRequest, options?: any) {
    return DefaultApiFp(this.configuration).createTrack(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates transfer from platform to artist connected account.
   * @param {CreateTransferRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createTransfer(fields: CreateTransferRequest, options?: any) {
    return DefaultApiFp(this.configuration).createTransfer(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes a comment.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteComment(commentId: string, options?: any) {
    return DefaultApiFp(this.configuration).deleteComment(commentId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Permanently deletes user's comments and all sub-comments from the platform.
   * @param {DeleteCommentsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteComments(fields: DeleteCommentsRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteComments(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes a file based on provided id, fileId for new files, objectId for old files.
   * @param {DeleteFileRequest} fields options
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteFile(fields: DeleteFileRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteFile(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes user's firebase profile entirely.
   * @param {DeleteFirebaseProfileRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteFirebaseProfile(
    fields: DeleteFirebaseProfileRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteFirebaseProfile(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Delete all purchases related to user or single purchase by id.
   * @param {DeleteIOSPurchasesRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteIOSPurchases(fields: DeleteIOSPurchasesRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteIOSPurchases(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes like.
   * @param {string} targetId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteLike(targetId: string, type: string, options?: any) {
    return DefaultApiFp(this.configuration).deleteLike(
      targetId,
      type,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Deletes notification by provided id.
   * @param {DeleteNotificationRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteNotification(fields: DeleteNotificationRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteNotification(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Delete all notifications related to user or entity.
   * @param {DeleteNotificationByTermRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteNotificationByTerm(
    fields: DeleteNotificationByTermRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteNotificationByTerm(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Delete all notifications related to user or entity.
   * @param {DeleteNotificationsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteNotifications(
    fields: DeleteNotificationsRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteNotifications(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Delete user's payment method.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePaymentMethod(options?: any) {
    return DefaultApiFp(this.configuration).deletePaymentMethod(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes post.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePost(postId: string, options?: any) {
    return DefaultApiFp(this.configuration).deletePost(postId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Permanently deletes user's posts and all related comments and media data.
   * @param {DeletePostsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePosts(fields: DeletePostsRequest, options?: any) {
    return DefaultApiFp(this.configuration).deletePosts(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Permanently deletes user's reports from the platform.
   * @param {DeleteReportsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteReports(fields: DeleteReportsRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteReports(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes stripe connected account by provided id.
   * @param {DeleteStripeConnectedAccountRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteStripeConnectedAccount(
    fields: DeleteStripeConnectedAccountRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteStripeConnectedAccount(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Deletes stripe customer by provided id.
   * @param {DeleteStripeCustomerRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteStripeCustomer(
    fields: DeleteStripeCustomerRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteStripeCustomer(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Deletes stripe entities from artist subscription settings based on provided user id.
   * @param {DeleteStripeEntitiesRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteStripeEntities(
    fields: DeleteStripeEntitiesRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).deleteStripeEntities(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Permanently deletes user's tips entities from the platform.
   * @param {DeleteTipsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteTips(fields: DeleteTipsRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteTips(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Removes track from Storage and database.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteTrack(trackId: string, options?: any) {
    return DefaultApiFp(this.configuration).deleteTrack(trackId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Permanently deletes user's tracks from the platform.
   * @param {DeleteTracksRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteTracks(fields: DeleteTracksRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteTracks(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Deletes user and all user's data from the platform.
   * @param {DeleteUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteUser(fields: DeleteUserRequest, options?: any) {
    return DefaultApiFp(this.configuration).deleteUser(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Exchanges disposable auth code for Ryddm API auth token.
   * @param {ExchangeDisposableAuthCodeRequest} fields Disposable auth code.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public exchangeDisposableAuthCode(
    fields: ExchangeDisposableAuthCodeRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).exchangeDisposableAuthCode(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Verify and exchange firebase id token with auth token.
   * @param {ExchangeTokenRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public exchangeToken(fields: ExchangeTokenRequest, options?: any) {
    return DefaultApiFp(this.configuration).exchangeToken(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Generates connected account link.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public generateConnectedAccountLink(userId: string, options?: any) {
    return DefaultApiFp(this.configuration).generateConnectedAccountLink(
      userId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Retrieves user's available and pending balances.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getBalance(options?: any) {
    return DefaultApiFp(this.configuration).getBalance(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns the list of tracks.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getBoostedTracks(options?: any) {
    return DefaultApiFp(this.configuration).getBoostedTracks(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns the list of tracks.
   * @param {boolean} [exclusiveOnly]
   * @param {Array<string>} [extend]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {Array<string>} [tags]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getChartTracks(
    exclusiveOnly?: boolean,
    extend?: Array<string>,
    limit?: number,
    offset?: number,
    tags?: Array<string>,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getChartTracks(
      exclusiveOnly,
      extend,
      limit,
      offset,
      tags,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of comments.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getComment(commentId: string, options?: any) {
    return DefaultApiFp(this.configuration).getComment(commentId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of comments.
   * @param {string} targetId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getComments(
    targetId: string,
    limit?: number,
    offset?: number,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getComments(
      targetId,
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns stripe connected account ready flag.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getConnectedAccountReady(options?: any) {
    return DefaultApiFp(this.configuration).getConnectedAccountReady(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Sends email with confirmation link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDeleteUserConfirmationLink(options?: any) {
    return DefaultApiFp(this.configuration).getDeleteUserConfirmationLink(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Generates disposable auth link.
   * @param {string} [redirectUrl]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDisposableAuthLink(redirectUrl?: string, options?: any) {
    return DefaultApiFp(this.configuration).getDisposableAuthLink(
      redirectUrl,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Creates a file.
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getFile(fileId: string, options?: any) {
    return DefaultApiFp(this.configuration).getFile(fileId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of followed by the user users.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getFollowedUserIDs(options?: any) {
    return DefaultApiFp(this.configuration).getFollowedUserIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Checks if post is already unlocked.
   * @param {string} postId
   * @param {string} sourceUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIsPostUnlocked(
    postId: string,
    sourceUserId: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getIsPostUnlocked(
      postId,
      sourceUserId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Checks if track is boosted and boost duration still going.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIsTrackBoosted(trackId: string, options?: any) {
    return DefaultApiFp(this.configuration).getIsTrackBoosted(trackId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Checks if track is already unlocked.
   * @param {string} sourceUserId
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIsTrackUnlocked(
    sourceUserId: string,
    trackId: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getIsTrackUnlocked(
      sourceUserId,
      trackId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns artists followed by user.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedArtists(
    userId: string,
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getLikedArtists(
      userId,
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of liked by the user comment ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedCommentIDs(options?: any) {
    return DefaultApiFp(this.configuration).getLikedCommentIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of liked by the user post ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedPostIDs(options?: any) {
    return DefaultApiFp(this.configuration).getLikedPostIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of posts liked by the user.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedPosts(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getLikedPosts(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of liked by the user track ids .
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedTrackIDs(options?: any) {
    return DefaultApiFp(this.configuration).getLikedTrackIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of tracks liked by the user.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLikedTracks(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getLikedTracks(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of notifications.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getNotifications(limit?: number, offset?: number, options?: any) {
    return DefaultApiFp(this.configuration).getNotifications(
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get user's payment method.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPaymentMethod(options?: any) {
    return DefaultApiFp(this.configuration).getPaymentMethod(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Get list of recent payments from stripe connected account.
   * @param {string} [endingBefore]
   * @param {number} [limit]
   * @param {string} [startingAfter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPaymentTransactions(
    endingBefore?: string,
    limit?: number,
    startingAfter?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getPaymentTransactions(
      endingBefore,
      limit,
      startingAfter,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get list of recent payouts from stripe connected account.
   * @param {string} [endingBefore]
   * @param {number} [limit]
   * @param {string} [startingAfter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPayoutTransactions(
    endingBefore?: string,
    limit?: number,
    startingAfter?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getPayoutTransactions(
      endingBefore,
      limit,
      startingAfter,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a post by id.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPost(postId: string, options?: any) {
    return DefaultApiFp(this.configuration).getPost(postId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Creates a post.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {'personal' | 'popular' | 'username'} [type]
   * @param {string} [userUsername]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPosts(
    limit?: number,
    offset?: number,
    type?: "personal" | "popular" | "username",
    userUsername?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getPosts(
      limit,
      offset,
      type,
      userUsername,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns the list of tracks for artist profile.
   * @param {Array<string>} [extend]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [userUsername]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getProfileTracks(
    extend?: Array<string>,
    limit?: number,
    offset?: number,
    userUsername?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getProfileTracks(
      extend,
      limit,
      offset,
      userUsername,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns artist's referral code.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getReferralCode(options?: any) {
    return DefaultApiFp(this.configuration).getReferralCode(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns status of report by provided id.
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getReport(reportId: string, options?: any) {
    return DefaultApiFp(this.configuration).getReport(reportId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns messages related to certain report.
   * @param {string} reportId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getReportMessages(
    reportId: string,
    limit?: number,
    offset?: number,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getReportMessages(
      reportId,
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of reports.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getReports(limit?: number, offset?: number, options?: any) {
    return DefaultApiFp(this.configuration).getReports(
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns artist referral stats.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getStats(options?: any) {
    return DefaultApiFp(this.configuration).getStats(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns artists the user is subscribed to.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscribedToArtists(
    userId: string,
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getSubscribedToArtists(
      userId,
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of user ids source user subscribed to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscribedToIDs(options?: any) {
    return DefaultApiFp(this.configuration).getSubscribedToIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns subscription settings.
   * @param {string} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscription(userId?: string, options?: any) {
    return DefaultApiFp(this.configuration).getSubscription(userId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns subscription stats.
   * @param {number} lastSubscribersCount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscriptionStats(lastSubscribersCount: number, options?: any) {
    return DefaultApiFp(this.configuration).getSubscriptionStats(
      lastSubscribersCount,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns subscription status.
   * @param {string} artistId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscriptionStatus(artistId: string, options?: any) {
    return DefaultApiFp(this.configuration).getSubscriptionStatus(
      artistId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Finds and returns suggested artist profiles.
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSuggestedArtists(limit?: number, options?: any) {
    return DefaultApiFp(this.configuration).getSuggestedArtists(limit, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a tip by id.
   * @param {string} tipId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTip(tipId: string, options?: any) {
    return DefaultApiFp(this.configuration).getTip(tipId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Find and return users income tip entries.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTips(limit?: number, offset?: number, options?: any) {
    return DefaultApiFp(this.configuration).getTips(
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns track by provided id.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTrack(trackId: string, options?: any) {
    return DefaultApiFp(this.configuration).getTrack(trackId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns the list of tracks.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {string} [userId]
   * @param {string} [userUsername]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTracks(
    limit?: number,
    offset?: number,
    search?: string,
    userId?: string,
    userUsername?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getTracks(
      limit,
      offset,
      search,
      userId,
      userUsername,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of posts unlocked by the user.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnlockedPosts(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getUnlockedPosts(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of unlocked by the user posts ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnlockedPostsIDs(options?: any) {
    return DefaultApiFp(this.configuration).getUnlockedPostsIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns a list of tracks unlocked by the user.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnlockedTracks(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getUnlockedTracks(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns a list of unlocked by the user tracks ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnlockedTracksIDs(options?: any) {
    return DefaultApiFp(this.configuration).getUnlockedTracksIDs(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns count of unread notifications.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnreadNotificationsCount(options?: any) {
    return DefaultApiFp(this.configuration).getUnreadNotificationsCount(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Finds and returns user by user id.
   * @param {Array<string>} [extend]
   * @param {string} [userId] UserID       string           &#x60;form:\&quot;userId\&quot;       json:\&quot;userId\&quot;       url:\&quot;userId\&quot; binding:\&quot;-\&quot;&#x60; UserUsername string           &#x60;form:\&quot;userUsername\&quot; json:\&quot;userUsername\&quot; url:\&quot;userUsername\&quot; binding:\&quot;-\&quot;&#x60;
   * @param {string} [userUsername]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUser(
    extend?: Array<string>,
    userId?: string,
    userUsername?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getUser(
      extend,
      userId,
      userUsername,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Return a list of user comments (admins only).
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUserComments(
    userId: string,
    limit?: number,
    offset?: number,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getUserComments(
      userId,
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Gets user deletion instruction.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUserDeletionInstructions(options?: any) {
    return DefaultApiFp(this.configuration).getUserDeletionInstructions(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Returns user suggestions by username.
   * @param {string} searchUsername
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUserSuggestions(
    searchUsername: string,
    limit?: number,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).getUserSuggestions(
      searchUsername,
      limit,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Checks if given username is available for registration.
   * @param {string} username Username
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUsernameAvailable(username: string, options?: any) {
    return DefaultApiFp(this.configuration).getUsernameAvailable(
      username,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles IOS IAP server-to-server notifications.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public iOSIAPWebhook(options?: any) {
    return DefaultApiFp(this.configuration).iOSIAPWebhook(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Unlocks post in ios.
   * @param {IOSPostUnlockRequest} fields Purchase info.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public iOSPostUnlock(fields: IOSPostUnlockRequest, options?: any) {
    return DefaultApiFp(this.configuration).iOSPostUnlock(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Boosts track in ios.
   * @param {IOSTrackBoostRequest} fields Purchase info.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public iOSTrackBoost(fields: IOSTrackBoostRequest, options?: any) {
    return DefaultApiFp(this.configuration).iOSTrackBoost(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Unlocks track in ios.
   * @param {IOSTrackUnlockRequest} fields Purchase info.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public iOSTrackUnlock(fields: IOSTrackUnlockRequest, options?: any) {
    return DefaultApiFp(this.configuration).iOSTrackUnlock(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Finds and returns all user's liked track IDs.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public likesGET(options?: any) {
    return DefaultApiFp(this.configuration).likesGET(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Exchanges Firebase ID token for Ryddm API auth token.
   * @param {LoginRequest} fields Firebase token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public login(fields: LoginRequest, options?: any) {
    return DefaultApiFp(this.configuration).login(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Pauses stripe subscriptions based on provided user id.
   * @param {PauseSubscriptionsRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public pauseSubscriptions(fields: PauseSubscriptionsRequest, options?: any) {
    return DefaultApiFp(this.configuration).pauseSubscriptions(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Recreates an account link for Stripe connected account.
   * @param {string} accountID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public paymentsaccountrefreshGET(accountID: string, options?: any) {
    return DefaultApiFp(this.configuration).paymentsaccountrefreshGET(
      accountID,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Completes creating Stripe connected account.
   * @param {string} accountID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public paymentsaccountreturnGET(accountID: string, options?: any) {
    return DefaultApiFp(this.configuration).paymentsaccountreturnGET(
      accountID,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles `checkout.session.completed` stripe event and deletes all old user cards.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public paymentswebhookscheckoutSessionCompletedPOST(options?: any) {
    return DefaultApiFp(
      this.configuration
    ).paymentswebhookscheckoutSessionCompletedPOST(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Handles `invoice.payment_failed` stripe event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public paymentswebhooksinvoicePaymentFailedPOST(options?: any) {
    return DefaultApiFp(
      this.configuration
    ).paymentswebhooksinvoicePaymentFailedPOST(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Pings microservice.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public ping(options?: any) {
    return DefaultApiFp(this.configuration).ping(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Reads notifications.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public readNotifications(options?: any) {
    return DefaultApiFp(this.configuration).readNotifications(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Verify and prolong users auth token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public refreshToken(options?: any) {
    return DefaultApiFp(this.configuration).refreshToken(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Exchanges Firebase ID token for Ryddm API auth token.
   * @param {RegisterRequest} fields Firebase token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public register(fields: RegisterRequest, options?: any) {
    return DefaultApiFp(this.configuration).register(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Exchanges Firebase ID token for Ryddm API auth token.
   * @param {RegisterFanRequest} fields Firebase token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public registerFan(fields: RegisterFanRequest, options?: any) {
    return DefaultApiFp(this.configuration).registerFan(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Resolves the reports related to passed report id.
   * @param {ResolveReportRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public resolveReport(fields: ResolveReportRequest, options?: any) {
    return DefaultApiFp(this.configuration).resolveReport(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Reverse previously created transfer from platform to artist connected account.
   * @param {ReverseTransferRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public reverseTransfer(fields: ReverseTransferRequest, options?: any) {
    return DefaultApiFp(this.configuration).reverseTransfer(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Searches track in database.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public searchArtists(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).searchArtists(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Searches track in database.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [search]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public searchTracks(
    limit?: number,
    offset?: number,
    search?: string,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).searchTracks(
      limit,
      offset,
      search,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles `customer.subscription.deleted` stripe event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public subscriptionswebhookssubscriptionDeletedPOST(options?: any) {
    return DefaultApiFp(
      this.configuration
    ).subscriptionswebhookssubscriptionDeletedPOST(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Unlocks post.
   * @param {UnlockPostRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public unlockPost(fields: UnlockPostRequest, options?: any) {
    return DefaultApiFp(this.configuration).unlockPost(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Unlocks track.
   * @param {UnlockTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public unlockTrack(fields: UnlockTrackRequest, options?: any) {
    return DefaultApiFp(this.configuration).unlockTrack(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Updates user activity time.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateActivityTime(options?: any) {
    return DefaultApiFp(this.configuration).updateActivityTime(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Updates subscription.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateSubscription(options?: any) {
    return DefaultApiFp(this.configuration).updateSubscription(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Updates subscription price.
   * @param {UpdateSubscriptionPriceRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateSubscriptionPrice(
    fields: UpdateSubscriptionPriceRequest,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).updateSubscriptionPrice(
      fields,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Updates track by track id.
   * @param {UpdateTrackRequest} fields Track information to update.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateTrack(fields: UpdateTrackRequest, options?: any) {
    return DefaultApiFp(this.configuration).updateTrack(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Updates the current user.
   * @param {UpdateUserRequest} fields User information to update.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateUser(fields: UpdateUserRequest, options?: any) {
    return DefaultApiFp(this.configuration).updateUser(fields, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Uploads the track to Google Cloud Storage.
   * @param {any} track Track to upload.
   * @param {any} cover Track cover to upload.
   * @param {string} name Track name (title).
   * @param {Array<string>} tags Track tags.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public uploadTrack(
    track: any,
    cover: any,
    name: string,
    tags: Array<string>,
    options?: any
  ) {
    return DefaultApiFp(this.configuration).uploadTrack(
      track,
      cover,
      name,
      tags,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Uploads the track cover to Google Cloud Storage.
   * @param {any} cover Cover to upload.
   * @param {string} trackID Track id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public uploadTrackCover(cover: any, trackID: string, options?: any) {
    return DefaultApiFp(this.configuration).uploadTrackCover(
      cover,
      trackID,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Uploads user avatar to Google Cloud Storage.
   * @param {any} avatar User avatar to upload.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public uploadUserAvatar(avatar: any, options?: any) {
    return DefaultApiFp(this.configuration).uploadUserAvatar(avatar, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Returns monetization info.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public webGetMonetizationStatus(options?: any) {
    return DefaultApiFp(this.configuration).webGetMonetizationStatus(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Handles `invoice.payment_failed` stripe event and sets subscription status to 'payment_failed'.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public webhookInvoicePaymentFailed(options?: any) {
    return DefaultApiFp(this.configuration).webhookInvoicePaymentFailed(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles `invoice.payment_succeeded` stripe event and sets subscription status to 'active'.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public webhookInvoicePaymentSucceeded(options?: any) {
    return DefaultApiFp(this.configuration).webhookInvoicePaymentSucceeded(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles `setup_intent.succeeded` stripe event and creates subscription in stripe and database.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public webhookSetupIntentSucceeded(options?: any) {
    return DefaultApiFp(this.configuration).webhookSetupIntentSucceeded(
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Handles `payment_intent.succeeded` stripe event and sets tip status to 'paid'.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public webhookTipPaymentIntentSucceeded(options?: any) {
    return DefaultApiFp(this.configuration).webhookTipPaymentIntentSucceeded(
      options
    )(this.fetch, this.basePath);
  }
}
